'use strict';
 
var modulo = angular.module('app',
               [
                'ui.bootstrap',
                'ngSanitize',

                'brian.factories',
                'brian.controllers',
                'brian.factories',
                'brian.directives',
                'leaflet-directive',
              ]).config(['$locationProvider',   function($locationProvider) {
                $locationProvider.hashPrefix('!');
               
              
              }]);


              


/*             How to stop logging on console? #1026 */
/*https://github.com/tombatossals/angular-leaflet-directive/issues/1026*/

modulo.config(function($logProvider){
  $logProvider.debugEnabled(false);
});
;-'use strict';
var brianControllers = angular.module('brian.controllers', ['ui.bootstrap']);

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

brianControllers.service('unico', function ($uibModalStack, modalFactory, $rootScope, spaceInfoFactory, notifyFactory, clicksFactory, $timeout) {

    $rootScope.missing_size       =  true;
    $rootScope.missing_telephone  =  true;
    
    //2020-02-01
    $rootScope.submission = {
        'option': '',
        'location': '',
        'intended_use_str': 'office',
        'pdf_issue': '',
        'page_id': 0,
        'ga_client_id': 0,
        'location_for_sale': ''
    };

    return {

        //2020-03-17
        contact_us_re_consulting: function (page_id) {
            $rootScope.submission.page_id             = 20;
            $uibModalStack.dismissAll();
            modalFactory.contact_us_re_consulting();
        },

        //2020-02-01
        contact_us_building_sales_v2: function (category) {
            if (category == 'medical')                          $rootScope.submission.intended_use_id = 133;
            else if (category == 'office')                      $rootScope.submission.intended_use_id = 134; /* no form */
            else if (category == 'condos')                      $rootScope.submission.intended_use_id = 135;
            else if (category == 'hospitality')                 $rootScope.submission.intended_use_id = 136;
            else if (category == 'industrial')                  $rootScope.submission.intended_use_id = 137;
            else if (category == 'multifamily')                 $rootScope.submission.intended_use_id = 139; /* no form */
            else if (category == 'land')                        $rootScope.submission.intended_use_id = 138;
            else if (category == 'retail')                      $rootScope.submission.intended_use_id = 140;
            else if (category == 'specialty')                   $rootScope.submission.intended_use_id = 141;
            else if (category == 'general')                     $rootScope.submission.intended_use_id = 142;
            else if (category == 'not_for_profit')              $rootScope.submission.intended_use_id = 145;
            else if (category == 'religious')                   $rootScope.submission.intended_use_id = 146;
            else if (category == 'specialty_school')            $rootScope.submission.intended_use_id = 147;
            else if (category == 'f_and_b')            $rootScope.submission.intended_use_id = 148;



            $uibModalStack.dismissAll();
            modalFactory.contact_us_building_for_sale_form_v1__b4();

        },

        notify_me: function (page_id, form) {

            $rootScope.submitted = true;

            function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }

            $rootScope.ajax_loader    = true;

            $rootScope.missing_size       =  true;
            $rootScope.missing_telephone  =  true;
            


            if (form.notify_form.$valid) {

                

                $rootScope.submission.page_id = page_id;
                $rootScope.submission.b = $("#b").val();
                $rootScope.submission.ga_client_id = readCookie('_ga');

                //2020-05-02
                // grecaptcha.execute('6LfagvEUAAAAANco96iY2EGGcERXrCKL1Cb59Gw6', {
                //     action: 'homepage'
                // }).then(function (token) {
                    $rootScope.submission.token        = token;
                    $rootScope.submission.http_referrer = document.URL;
                    $rootScope.notify_me_thank_you = false;
                    notifyFactory.create($rootScope.submission).$promise.then(function (data) {
                        $rootScope.ajax_loader             = false;
                        $rootScope.notify_me_thank_you     = true;

                        if ($rootScope.submission.size) {
                            $rootScope.missing_size       =  false;
                        }

                        if ($rootScope.submission.telephone) {
                            $rootScope.missing_telephone  =  false;
                        }

                    });
                // });




            } else {
                $rootScope.ajax_loader = false;
            }
        },
        find_my_space_top: function (page_id) {
            $rootScope.specific_req_on = false;
            $rootScope.submission.page_id = page_id;
            // 2019-03-16 added
            var new_obj = {
                'name': 'find_my_space_top',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }
            clicksFactory.create(new_obj);
            $uibModalStack.dismissAll();
            //modalFactory.contact_us_form();
            modalFactory.contact_us_form_b4();

        },
        contact_us__fn: function (page_id) {
            $rootScope.specific_req_on = false;
            $rootScope.submission.page_id = page_id;

            // 20190316 added
            var new_obj = {
                'name': 'contact_us',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }
            clicksFactory.create(new_obj);
            $uibModalStack.dismissAll();

            modalFactory.contact_us2_form_b4();
        },

        contact_us__fn3: function (page_id) {
            $uibModalStack.dismissAll();

            $rootScope.specific_req_on = false;
            $rootScope.submission.page_id = page_id;
            $rootScope.submission.intended_use_id = 1;
            var new_obj = {
                'name': 'contact_us',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }

            clicksFactory.create(new_obj);

            //20251004
            document.addEventListener('click', function (e) {
                if (e.target && e.target.tagName === 'A') {
                    e.target.blur(); // remove focus from the link
                }
            });


            modalFactory.contact_us2_form_b5();
        },


        contact_us: function (category) {
            $rootScope.submission.intended_use_id = 1;
            if (category == 'office') $rootScope.submission.intended_use_id = 1;
            else if (category == 'retail') $rootScope.submission.intended_use_id = 2;
            else if (category == 'medical') $rootScope.submission.intended_use_id = 9;
            else if (category == 'educational') $rootScope.submission.intended_use_id = 6;
            else if (category == 'building_space_notify_me')  {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Please notify me when a new space is available';
                
            }
            else if (category == 'coworking1') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Windowed office/person, Class A, $ 2,000/month';
                $rootScope.submission.budget = '$2000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking2') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Windowed office/person, Class B, $ 1,250/month';
                $rootScope.submission.budget = '$1250/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking3') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Windowed office/person, Class C, $ 750/month';
                $rootScope.submission.budget = '$750/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking4') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Interior office/person, Class A, $ 1,250/month';
                $rootScope.submission.budget = '$1250/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking5') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Interior office/person, Class B, $ 750/month';
                $rootScope.submission.budget = '$750/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking6') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Interior office/person, Class C, $ 500/month';
                $rootScope.submission.budget = '$2500/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking7') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Team Rooms, Class A, $ 10,000/month';
                $rootScope.submission.budget = '$10,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking8') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Team Rooms, Class B, $ 8,000/month';
                $rootScope.submission.budget = '$8,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking9') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Team Rooms, Class C, $ 5,000/month';
                $rootScope.submission.budget = '$5,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking10') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Suites, Class A, $ 20,000/month';
                $rootScope.submission.budget = '$20,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking11') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Suites, Class B, $ 12,000/month';
                $rootScope.submission.budget = '$12,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }
            else if (category == 'coworking12') {
                $rootScope.submission.intended_use_id = 1;
                $rootScope.submission.needs = 'Re Coworking Office Spaces for Rent, Suites, Class C, $ 7,000/month';
                $rootScope.submission.budget = '$7,000/month';
                $rootScope.submission.shared_space = 'Coworking';
            }




            $rootScope.specific_req_on = false;
            // 2019-03-16 added
            var new_obj = {
                'name': 'contact_us',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }
            clicksFactory.create(new_obj);
            $uibModalStack.dismissAll();

            modalFactory.contact_us_form_b4();

        },

        

        //2019-06-02 added
        chat_us: function (page_id) {
            $rootScope.specific_req_on = false;
            $rootScope.submission.page_id = page_id;
            // 2019-03-16 added
            var new_obj = {
                'name': 'chat_us',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }
            clicksFactory.create(new_obj);
            $uibModalStack.dismissAll();
            modalFactory.chat_us_form();
        },
        // contact_us_building_sales: function(page_id, type_of_use) {

        //     $rootScope.specific_req_on          = false;
        //     $rootScope.submission.page_id       = page_id;
        //     $rootScope.submission.type_of_use   = type_of_use;
        //     $uibModalStack.dismissAll();
        //     modalFactory.contact_us_building_for_sale_form();
        // },
        find_my_space: function (category) {



            if (category == 'office') $rootScope.submission.intended_use_id = 1;
            else if (category == 'retail') $rootScope.submission.intended_use_id = 1;
            else if (category == 'medical') $rootScope.submission.intended_use_id = 9;
            else if (category == 'educational') $rootScope.submission.intended_use_id = 6;


            // 2019-03-16 added
            var new_obj = {
                'name': 'find_my_space',
                'ga_client_id': readCookie('_ga'),
                'http_referrer': document.URL
            }
            clicksFactory.create(new_obj);

            $rootScope.specific_req_on = false;
            //$rootScope.submission.page_id           = page_id;


            // $rootScope.submission.clusters          = $rootScope.clusters;
            // $rootScope.submission.clusters          = $rootScope.clusters2;

            $uibModalStack.dismissAll();
            // //console.log($rootScope.clusters);
            // //console.log($rootScope.clusters2);
            modalFactory.find_my_space_form();
        },
        show_space_info: function (space_panda_key) {

            var obj = {
                'k': space_panda_key
            };

            spaceInfoFactory.query(obj).$promise.then(function (data) {
                //$rootScope.submission.page_id  = 6;
                $rootScope.submission.k = space_panda_key;
                $rootScope.submission.needs = '';
 
                $rootScope.spaceInfo = data;
                $uibModalStack.dismissAll();
                //contact_us(6);


                /* 2020-04-21 */

                $rootScope.specific_req_on = false;
                // 2019-03-16 added
                var new_obj = {
                    'name': 'table_w_4cols',
                    'ga_client_id': readCookie('_ga'),
                    'http_referrer': document.URL
                }
                clicksFactory.create(new_obj);

                $rootScope.submission.intended_use_id = 1;

                var h1_form = "Office For Rent";
                if (document.URL.includes('retail')) {
                    $rootScope.submission.intended_use_id = 2;
                    h1_form = "Retail Space For Rent";
                } else if (document.URL.includes('medical')) {
                    $rootScope.submission.intended_use_id = 9;
                    h1_form = "Medical Space For Rent";
                } else if (document.URL.includes('education')) {
                    $rootScope.submission.intended_use_id = 6;
                    h1_form = "Educational Space For Rent";
                }
                $rootScope.submission.spaceInfo = data;
                $rootScope.submission.size = data.size;
                $rootScope.submission.needs = data.message;
                $rootScope.submission.budget = data.asking_rent;
                
                //20240303
                $rootScope.h1_form = h1_form;

 
                

                //2020-05-14
                modalFactory.contact_us_form_b4();
                //modalFactory.contact_us_form();






                //modalFactory.show_space_info();

            });

        },

        search_results: function (page_id) {

            $rootScope.submission.page_id = page_id;
            $uibModalStack.dismissAll();
            modalFactory.search_results_table();
            $rootScope.search_results_table = true;

        },

        download_report: function (pdf_issue) {
            $uibModalStack.dismissAll();

            $rootScope.submission.pdf_issue = pdf_issue;
            modalFactory.download_form();
        },

        set_submission_location: function (new_value) {
            $rootScope.submission.location = new_value;
        },
    };
});

brianControllers.controller("pulsarCtrl", ["$scope", "$filter", "$timeout", "clientFactory", "modalFactory", "$uibModalStack", "spaceFactory", "unico", "searchResultsFactory", "leafletData", "marcadorFactory", function ($scope, $filter, $timeout, clientFactory, modalFactory, $uibModalStack, spaceFactory, unico, searchResultsFactory, leafletData, marcadorFactory) {

 
    $scope.contact_us_re_consulting = function () {
        unico.contact_us_re_consulting(10);

    };



    //2019-10-31
    $scope.neighborhood_arr = [{
            'keyword': 'penn_plaza',
            'neighborhood_name': 'Penn Plaza',
            'neighborhood_src': 'penn_plaza_nyc_750px.jpg'
        },
        {
            'keyword': 'midtown_west',
            'neighborhood_name': 'Midtown West',
            'neighborhood_src': 'midtown_west_nyc.jpg'
        },
        {
            'keyword': 'chelsea',
            'neighborhood_name': 'Chelsea',
            'neighborhood_src': 'chelsea_nyc.jpg'
        },
        {
            'keyword': 'soho',
            'neighborhood_name': 'Soho',
            'neighborhood_src': 'soho_nyc.jpg'
        },
        {
            'keyword': 'wall_street',
            'neighborhood_name': 'Wall Street',
            'neighborhood_src': 'wall_street_nyc.jpg'
        },
        {
            'keyword': 'financial_district',
            'neighborhood_name': 'Financial District',
            'neighborhood_src': 'financial_district_nyc.jpg'
        },
        {
            'keyword': 'tribeca',
            'neighborhood_name': 'Tribeca',
            'neighborhood_src': 'tribeca_nyc.jpg'
        },
        {
            'keyword': 'midtown_east',
            'neighborhood_name': 'Midtown East',
            'neighborhood_src': 'midtown_east_nyc.jpg'
        },

    ]
    $scope.map_image = false;
    $scope.map_image__fn = function (keyword) {
        $scope.map_image = $filter("filter")($scope.neighborhood_arr, {
            'keyword': keyword
        })[0];

    };

    //2019-09-22
    $scope.submission.category = 'Office';
    $scope.submission_category__fn = function (category) {
        //if (type_of_use == 'Medical') $scope.submission.intended_use_id = 132;
        /*  https://www.optimalspaces.com/buildings-for-sale/ */
        //$scope.contact_us_building_sales(10, type_of_use);
        unico.contact_us_building_sales_v2(category);
    };



    //2019-08-24
    $scope.nSelection = 'Office';
    $scope.nSelection__fn = function (type_of_use) {
        $scope.nSelection = type_of_use;
    };


    /////////////// map_advanced /////////////////
    //2019-03-24
    //very sure below logic is 100% easier but have 0 time for it.
    $scope.clusters2 = [];
    $scope.clusters2_indexes = [];
    $scope.x_arr = [
        [-73.991379, 40.776868],
        [-73.991730, 40.776381],
        [-73.992367, 40.775521],
        [-73.992442, 40.775371],
        [-73.992448, 40.775250],
        [-73.992428, 40.775142],
        [-73.992453, 40.775015],
        [-73.992491, 40.774925],
        [-73.992611, 40.774920],
        [-73.992609, 40.774907],
        [-73.993367, 40.773833],
        [-73.993392, 40.773821],
        [-73.993428, 40.773786],
        [-73.993492, 40.773688],
        [-73.993533, 40.773642],
        [-73.993627, 40.773563],
        [-73.993682, 40.773496],
        [-73.993737, 40.773374],
        [-73.993767, 40.773355],
        [-73.993803, 40.773352],
        [-73.993855, 40.773320],
        [-73.993832, 40.773268],
        [-73.993893, 40.773144],
        [-73.993894, 40.773138],
        [-73.993913, 40.773133],
        [-73.996019, 40.774019],
        [-73.996146, 40.773860],
        [-73.996080, 40.773831],
        [-73.996141, 40.773737],
        [-73.995131, 40.773303],
        [-73.995056, 40.773382],
        [-73.995050, 40.773380],
        [-73.995026, 40.773425],
        [-73.994259, 40.773108],
        [-73.994295, 40.773049],
        [-73.994290, 40.773046],
        [-73.994301, 40.773044],
        [-73.994347, 40.772982],
        [-73.993996, 40.772834],
        [-73.993941, 40.772897],
        [-73.993880, 40.772913],
        [-73.993816, 40.772892],
        [-73.994148, 40.772438],
        [-73.994264, 40.772479],
        [-73.994354, 40.772493],
        [-73.996101, 40.773233],
        [-73.996203, 40.773099],
        [-73.994427, 40.772340],
        [-73.994747, 40.771888],
        [-73.996874, 40.772769],
        [-73.997067, 40.772541],
        [-73.996352, 40.772221],
        [-73.994956, 40.771618],
        [-73.994962, 40.771609],
        [-73.994952, 40.771606],
        [-73.994964, 40.771601],
        [-73.994993, 40.771564],
        [-73.994915, 40.771462],
        [-73.994966, 40.771392],
        [-73.995009, 40.771405],
        [-73.995107, 40.771404],
        [-73.995282, 40.771154],
        [-73.995298, 40.771146],
        [-73.995323, 40.771166],
        [-73.995329, 40.771161],
        [-73.995892, 40.771398],
        [-73.995969, 40.771281],
        [-73.995719, 40.771168],
        [-73.995749, 40.771117],
        [-73.995422, 40.770976],
        [-73.995756, 40.770504],
        [-73.995876, 40.770565],
        [-73.995996, 40.770406],
        [-73.995867, 40.770349],
        [-73.996308, 40.769757],
        [-73.998725, 40.770773],
        [-73.998994, 40.770436],
        [-73.998414, 40.770188],
        [-73.996583, 40.769404],
        [-73.997059, 40.768717],
        [-73.999363, 40.769705],
        [-73.999372, 40.769694],
        [-73.999379, 40.769706],
        [-73.999497, 40.769739],
        [-73.999743, 40.769448],
        [-73.999749, 40.769423],
        [-73.999560, 40.769334],
        [-73.996455, 40.768046],
        [-73.997131, 40.767125],
        [-73.999532, 40.768132],
        [-73.999532, 40.768100],
        [-74.000414, 40.768461],
        [-74.000423, 40.768447],
        [-74.000429, 40.768453],
        [-74.000441, 40.768455],
        [-74.000636, 40.768190],
        [-73.997391, 40.766810],
        [-73.996879, 40.766833],
        [-73.980442, 40.759888],
        [-73.976251, 40.765680],
        [-73.981118, 40.767742],
        [-73.981162, 40.767786],
        [-73.981199, 40.767816],
        [-73.981467, 40.767993],
        [-73.981461, 40.768089],
        [-73.981525, 40.768246],
        [-73.981560, 40.768284],
        [-73.981576, 40.768296],
        [-73.981580, 40.768380],
        [-73.981572, 40.768452],
        [-73.981561, 40.768503],
        [-73.981534, 40.768567],
        [-73.981437, 40.768705],
        [-73.981398, 40.768783],
        [-73.979195, 40.771782]
    ];
    $scope.clusters2.push($scope.x_arr);
    $scope.x_arr = [
        [-74.007325, 40.754826],
        [-74.007393, 40.754745],
        [-74.007270, 40.754690],
        [-74.007447, 40.754435],
        [-74.007578, 40.754485],
        [-74.007714, 40.754301],
        [-74.007600, 40.754235],
        [-74.008367, 40.752349],
        [-74.008752, 40.752436],
        [-74.008734, 40.752470],
        [-74.008872, 40.752530],
        [-74.008946, 40.752429],
        [-74.008818, 40.752372],
        [-74.008831, 40.752350],
        [-74.009462, 40.752607],
        [-74.009456, 40.752619],
        [-74.009318, 40.752563],
        [-74.009272, 40.752571],
        [-74.009251, 40.752595],
        [-74.009261, 40.752605],
        [-74.009214, 40.752697],
        [-74.009282, 40.752610],
        [-74.009373, 40.752649],
        [-74.009308, 40.752740],
        [-74.009324, 40.752748],
        [-74.009395, 40.752659],
        [-74.009483, 40.752699],
        [-74.009424, 40.752785],
        [-74.009440, 40.752796],
        [-74.009505, 40.752710],
        [-74.009602, 40.752749],
        [-74.009539, 40.752836],
        [-74.009550, 40.752841],
        [-74.009617, 40.752759],
        [-74.009712, 40.752794],
        [-74.009654, 40.752880],
        [-74.009668, 40.752891],
        [-74.009733, 40.752805],
        [-74.009794, 40.752831],
        [-74.009749, 40.752900],
        [-74.009893, 40.752969],
        [-74.010027, 40.752790],
        [-74.008479, 40.752147],
        [-74.008523, 40.752042],
        [-74.009290, 40.752326],
        [-74.009312, 40.752298],
        [-74.009456, 40.752347],
        [-74.009446, 40.752359],
        [-74.009631, 40.752434],
        [-74.009600, 40.752493],
        [-74.009816, 40.752585],
        [-74.009894, 40.752521],
        [-74.010089, 40.752588],
        [-74.010148, 40.752508],
        [-74.009112, 40.752073],
        [-74.009115, 40.752055],
        [-74.008577, 40.751881],
        [-74.009037, 40.750668],
        [-74.010595, 40.751325],
        [-74.010700, 40.751051],
        [-74.009124, 40.750401],
        [-74.009281, 40.750002],
        [-74.009591, 40.749981],
        [-74.009990, 40.748952],
        [-74.011223, 40.748967],
        [-74.011277, 40.748664],
        [-74.008914, 40.748393],
        [-74.009043, 40.747730],
        [-74.011254, 40.747982],
        [-74.011291, 40.747975],
        [-74.011314, 40.747964],
        [-74.011330, 40.747944],
        [-74.011396, 40.747587],
        [-74.011387, 40.747570],
        [-74.011348, 40.747550],
        [-74.010810, 40.747487],
        [-74.010811, 40.747456],
        [-74.010222, 40.747390],
        [-74.010221, 40.747402],
        [-74.010138, 40.747392],
        [-74.010135, 40.747422],
        [-74.009926, 40.747398],
        [-74.009920, 40.747370],
        [-74.009941, 40.747370],
        [-74.009946, 40.747337],
        [-74.009527, 40.747308],
        [-74.009527, 40.747325],
        [-74.009548, 40.747332],
        [-74.009542, 40.747355],
        [-74.009172, 40.747322],
        [-74.009238, 40.746902],
        [-74.009198, 40.746898],
        [-74.009218, 40.746715],
        [-74.011492, 40.746950],
        [-74.011515, 40.746927],
        [-74.011581, 40.746563],
        [-74.011552, 40.746538],
        [-74.011515, 40.746525],
        [-74.009338, 40.746300],
        [-74.009438, 40.745730],
        [-74.009481, 40.745735],
        [-74.009479, 40.745749],
        [-74.010529, 40.745861],
        [-74.010531, 40.745844],
        [-74.010588, 40.745846],
        [-74.010593, 40.745832],
        [-74.011638, 40.745939],
        [-74.011673, 40.745931],
        [-74.011829, 40.745079],
        [-74.011776, 40.745071],
        [-74.011704, 40.745471],
        [-74.011143, 40.745406],
        [-74.011213, 40.745018],
        [-74.011158, 40.745002],
        [-74.011085, 40.745402],
        [-74.010520, 40.745329],
        [-74.010592, 40.744951],
        [-74.010533, 40.744941],
        [-74.010466, 40.745343],
        [-74.009949, 40.745288],
        [-74.010016, 40.744899],
        [-74.009975, 40.744898],
        [-74.009912, 40.745278],
        [-74.009555, 40.745246],
        [-74.009584, 40.744931],
        [-74.008721, 40.744850],
        [-74.008882, 40.743857],
        [-74.009383, 40.743912],
        [-74.009422, 40.743714],
        [-74.009509, 40.743617],
        [-74.012023, 40.743885],
        [-74.012067, 40.743856],
        [-74.012116, 40.743513],
        [-74.012098, 40.743485],
        [-74.009551, 40.743212],
        [-74.009598, 40.742904],
        [-74.009063, 40.742831],
        [-74.009258, 40.741831],
        [-74.009421, 40.741846],
        [-74.009505, 40.741449],
        [-74.012094, 40.741682],
        [-74.012151, 40.741462],
        [-74.009633, 40.741175],
        [-74.009635, 40.741150],
        [-74.009379, 40.741112],
        [-74.009464, 40.740898],
        [-74.006389, 40.739622],
        [-74.006489, 40.739401],
        [-74.004198, 40.739416],
        [-74.004044, 40.739468],
        [-74.003882, 40.739399],
        [-74.003885, 40.738754],
        [-74.002406, 40.738760],
        [-74.001769, 40.737674],
        [-73.994592, 40.734665],
        [-73.986390, 40.745906]
    ];
    $scope.clusters2.push($scope.x_arr);
    $scope.x_arr = [
        [-74.003516, 40.720522],
        [-74.010165, 40.712054],
        [-74.008656, 40.711348],
        [-74.008502, 40.711311],
        [-74.008421, 40.711312],
        [-74.007018, 40.711660],
        [-74.005915, 40.711912],
        [-74.005747, 40.711981],
        [-74.005467, 40.712042],
        [-74.005288, 40.712048],
        [-74.005214, 40.712043],
        [-74.005138, 40.712029],
        [-74.004897, 40.712003],
        [-74.004594, 40.711840],
        [-74.004514, 40.711813],
        [-74.004321, 40.711773],
        [-74.004170, 40.711774],
        [-74.004104, 40.711783],
        [-74.000986, 40.709307],
        [-74.000070, 40.708637],
        [-73.999203, 40.707945],
        [-73.999139, 40.707984],
        [-73.999045, 40.708042],
        [-73.998413, 40.708330],
        [-73.998207, 40.708424],
        [-73.998164, 40.708428],
        [-73.998148, 40.708442],
        [-73.997883, 40.708534],
        [-73.997512, 40.708630],
        [-73.997395, 40.708664],
        [-73.997233, 40.708697],
        [-73.996805, 40.708769],
        [-73.996322, 40.708834],
        [-73.995668, 40.708926],
        [-73.994810, 40.709051],
        [-73.994537, 40.709102],
        [-73.994375, 40.709156],
        [-73.994283, 40.709166],
        [-73.994277, 40.709161],
        [-73.994253, 40.709169],
        [-73.994126, 40.709191],
        [-73.993896, 40.709199],
        [-73.993896, 40.709195],
        [-73.993875, 40.709203],
        [-73.993674, 40.709207],
        [-73.993593, 40.709229],
        [-73.992294, 40.709425],
        [-73.992271, 40.709437],
        [-73.992048, 40.709472],
        [-73.991923, 40.709491],
        [-73.995477, 40.715957],
        [-73.998605, 40.717089],
        [-73.998901, 40.717231],
        [-73.999069, 40.717339],
        [-74.003516, 40.720522]
    ];
    $scope.clusters2.push($scope.x_arr);
    $scope.x_arr = [
        [-74.010578, 40.709105],
        [-74.011112, 40.708563],
        [-74.011307, 40.708325],
        [-74.012503, 40.706752],
        [-74.013294, 40.705822],
        [-74.013385, 40.705750],
        [-74.013893, 40.705126],
        [-74.014169, 40.704669],
        [-74.014349, 40.704514],
        [-74.014315, 40.704444],
        [-74.014307, 40.704405],
        [-74.014451, 40.703590],
        [-74.014507, 40.703283],
        [-74.014508, 40.703240],
        [-74.014486, 40.703108],
        [-74.014435, 40.702940],
        [-74.014356, 40.702807],
        [-74.013877, 40.702360],
        [-74.013954, 40.702021],
        [-74.013958, 40.701495],
        [-74.013904, 40.700956],
        [-74.013549, 40.700913],
        [-74.013503, 40.700674],
        [-74.013565, 40.700663],
        [-74.013557, 40.700569],
        [-74.013543, 40.700563],
        [-74.013540, 40.700514],
        [-74.013533, 40.700500],
        [-74.013522, 40.700494],
        [-74.013519, 40.700481],
        [-74.013490, 40.700481],
        [-74.013487, 40.700473],
        [-74.013541, 40.700467],
        [-74.013535, 40.700422],
        [-74.013479, 40.700429],
        [-74.013479, 40.700418],
        [-74.013519, 40.700405],
        [-74.013527, 40.700208],
        [-74.013549, 40.700201],
        [-74.013566, 40.700210],
        [-74.013576, 40.700210],
        [-74.013584, 40.700170],
        [-74.013632, 40.700100],
        [-74.013550, 40.700055],
        [-74.013502, 40.700101],
        [-74.013440, 40.700242],
        [-74.013439, 40.700394],
        [-74.013427, 40.700414],
        [-74.013429, 40.700447],
        [-74.013238, 40.700466],
        [-74.013222, 40.700431],
        [-74.013211, 40.700431],
        [-74.013205, 40.700392],
        [-74.013167, 40.700280],
        [-74.013100, 40.699767],
        [-74.013064, 40.699733],
        [-74.013038, 40.699733],
        [-74.013015, 40.699740],
        [-74.013002, 40.699749],
        [-74.012998, 40.699749],
        [-74.012977, 40.699768],
        [-74.012990, 40.699881],
        [-74.012995, 40.699883],
        [-74.013049, 40.700089],
        [-74.013028, 40.700089],
        [-74.013028, 40.700102],
        [-74.013049, 40.700137],
        [-74.013071, 40.700361],
        [-74.013054, 40.700366],
        [-74.013011, 40.700406],
        [-74.013006, 40.700417],
        [-74.013006, 40.700431],
        [-74.013017, 40.700443],
        [-74.013039, 40.700452],
        [-74.013071, 40.700473],
        [-74.012874, 40.700490],
        [-74.012859, 40.700467],
        [-74.012841, 40.700469],
        [-74.012792, 40.700298],
        [-74.012711, 40.700194],
        [-74.012612, 40.700114],
        [-74.012570, 40.700096],
        [-74.012540, 40.700096],
        [-74.012509, 40.700102],
        [-74.012483, 40.700125],
        [-74.012493, 40.700262],
        [-74.012505, 40.700309],
        [-74.012504, 40.700340],
        [-74.012507, 40.700339],
        [-74.012566, 40.700549],
        [-74.012530, 40.700562],
        [-74.012414, 40.700348],
        [-74.012269, 40.700396],
        [-74.012373, 40.700595],
        [-74.012358, 40.700600],
        [-74.012250, 40.700404],
        [-74.012250, 40.700380],
        [-74.012243, 40.700362],
        [-74.012230, 40.700368],
        [-74.012125, 40.700187],
        [-74.012097, 40.700174],
        [-74.012076, 40.700159],
        [-74.012055, 40.700165],
        [-74.011980, 40.700077],
        [-74.011917, 40.700069],
        [-74.011856, 40.700094],
        [-74.011895, 40.700214],
        [-74.012029, 40.700161],
        [-74.012027, 40.700177],
        [-74.012263, 40.700591],
        [-74.012049, 40.700659],
        [-74.011978, 40.700483],
        [-74.011943, 40.700488],
        [-74.011921, 40.700476],
        [-74.011878, 40.700386],
        [-74.011907, 40.700370],
        [-74.011819, 40.700165],
        [-74.011751, 40.700183],
        [-74.011894, 40.700488],
        [-74.011759, 40.700517],
        [-74.011796, 40.700615],
        [-74.011967, 40.700577],
        [-74.012006, 40.700677],
        [-74.011790, 40.700722],
        [-74.011732, 40.700589],
        [-74.011726, 40.700582],
        [-74.011679, 40.700465],
        [-74.011659, 40.700437],
        [-74.011615, 40.700422],
        [-74.011586, 40.700425],
        [-74.011571, 40.700435],
        [-74.011573, 40.700473],
        [-74.011663, 40.700715],
        [-74.011662, 40.700752],
        [-74.011481, 40.700797],
        [-74.011357, 40.700556],
        [-74.011333, 40.700537],
        [-74.011285, 40.700539],
        [-74.011268, 40.700554],
        [-74.011262, 40.700570],
        [-74.011319, 40.700831],
        [-74.011115, 40.700878],
        [-74.011082, 40.700868],
        [-74.011041, 40.700872],
        [-74.011088, 40.701027],
        [-74.011190, 40.701024],
        [-74.011254, 40.701206],
        [-74.011070, 40.701251],
        [-74.011131, 40.701416],
        [-74.011131, 40.701439],
        [-74.009764, 40.701777],
        [-74.009741, 40.701777],
        [-74.009727, 40.701791],
        [-74.009687, 40.701791],
        [-74.009644, 40.701808],
        [-74.009641, 40.701804],
        [-74.009556, 40.701826],
        [-74.008569, 40.700517],
        [-74.008306, 40.700636],
        [-74.008484, 40.700882],
        [-74.007548, 40.701299],
        [-74.007710, 40.701512],
        [-74.008662, 40.701105],
        [-74.009256, 40.701917],
        [-74.009079, 40.701973],
        [-74.007635, 40.702855],
        [-74.007582, 40.702904],
        [-74.007502, 40.703056],
        [-74.007456, 40.703100],
        [-74.007150, 40.703278],
        [-74.007131, 40.703277],
        [-74.006737, 40.703526],
        [-74.005443, 40.702395],
        [-74.005266, 40.702516],
        [-74.006550, 40.703673],
        [-74.006127, 40.703936],
        [-74.005999, 40.703821],
        [-74.005971, 40.703838],
        [-74.005974, 40.703841],
        [-74.004222, 40.704977],
        [-74.004332, 40.705078],
        [-74.004781, 40.705185],
        [-74.005467, 40.705689],
        [-74.005639, 40.705778],
        [-74.006824, 40.706681],
        [-74.007436, 40.707169],
        [-74.008321, 40.707661],
        [-74.009433, 40.708574],
        [-74.009690, 40.708714],
        [-74.010580, 40.709105]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.976251, 40.76568],
        [-73.981806, 40.758026],
        [-73.969881, 40.752991],
        [-73.968981, 40.754252],
        [-73.966615, 40.753246],
        [-73.96661, 40.753243],
        [-73.964233, 40.752176],
        [-73.963489, 40.752988],
        [-73.96347, 40.752994],
        [-73.961767, 40.754917],
        [-73.96176, 40.754942],
        [-73.961676, 40.75504],
        [-73.961569, 40.755147],
        [-73.961354, 40.755304],
        [-73.961325, 40.755317],
        [-73.960768, 40.755756],
        [-73.960761, 40.755784],
        [-73.960244, 40.756363],
        [-73.960207, 40.756503],
        [-73.959283, 40.757732],
        [-73.958549, 40.758472],
        [-73.958264, 40.75875],
        [-73.958155, 40.758815],
        [-73.95483, 40.761845],
        [-73.970274, 40.768022],
        [-73.973007, 40.764287]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.986418, 40.745908],
        [-73.994592, 40.734665],
        [-73.976640, 40.727090],
        [-73.977104, 40.726460],
        [-73.977299, 40.726137],
        [-73.977531, 40.725830],
        [-73.973498, 40.724137],
        [-73.972210, 40.723751],
        [-73.971785, 40.725789],
        [-73.971747, 40.725798],
        [-73.971729, 40.725805],
        [-73.971647, 40.726306],
        [-73.971644, 40.726415],
        [-73.971480, 40.727349],
        [-73.971507, 40.727376],
        [-73.971568, 40.727384],
        [-73.971397, 40.728705],
        [-73.971397, 40.728876],
        [-73.971407, 40.728980],
        [-73.971432, 40.729111],
        [-73.971477, 40.729266],
        [-73.971641, 40.729548],
        [-73.971692, 40.729630],
        [-73.971749, 40.729719],
        [-73.971820, 40.729812],
        [-73.971861, 40.729865],
        [-73.971961, 40.729972],
        [-73.972099, 40.730099],
        [-73.972221, 40.730194],
        [-73.972443, 40.730337],
        [-73.973359, 40.731183],
        [-73.973381, 40.731211],
        [-73.973414, 40.731286],
        [-73.973864, 40.733092],
        [-73.973778, 40.733091],
        [-73.973703, 40.733119],
        [-73.973696, 40.733139],
        [-73.973699, 40.733167],
        [-73.973884, 40.733336],
        [-73.973945, 40.733382],
        [-73.974409, 40.735243],
        [-73.974380, 40.735239],
        [-73.973534, 40.734883],
        [-73.973520, 40.734891],
        [-73.973494, 40.734921],
        [-73.973434, 40.734914],
        [-73.973361, 40.734933],
        [-73.973299, 40.734966],
        [-73.973261, 40.735018],
        [-73.973255, 40.735076],
        [-73.973275, 40.735119],
        [-73.973296, 40.735144],
        [-73.973299, 40.735205],
        [-73.973433, 40.735271],
        [-73.974177, 40.735579],
        [-73.974343, 40.735593],
        [-73.974470, 40.735588],
        [-73.974473, 40.735595],
        [-73.974484, 40.735596],
        [-73.974495, 40.735669],
        [-73.974479, 40.736004],
        [-73.974421, 40.736307],
        [-73.974392, 40.736373],
        [-73.973019, 40.735783],
        [-73.972827, 40.735723],
        [-73.972475, 40.735747],
        [-73.972639, 40.739191],
        [-73.972427, 40.739984],
        [-73.973200, 40.740348]
    ];
    $scope.clusters2.push($scope.x_arr); //gram

    $scope.x_arr = [
        [-73.978566, 40.756657],
        [-73.982736, 40.750967],
        [-73.974050, 40.747294],
        [-73.969881, 40.752991]
    ];
    $scope.clusters2.push($scope.x_arr); // gc

    $scope.x_arr = [
        [-74.009493, 40.740803],
        [-74.009505, 40.740751],
        [-74.009503, 40.740752],
        [-74.009534, 40.740685],
        [-74.009578, 40.740632],
        [-74.009643, 40.740603],
        [-74.009670, 40.740599],
        [-74.009802, 40.740611],
        [-74.010163, 40.740615],
        [-74.010393, 40.740633],
        [-74.010724, 40.740640],
        [-74.010853, 40.740656],
        [-74.010995, 40.740656],
        [-74.011110, 40.740666],
        [-74.011260, 40.740688],
        [-74.011376, 40.740688],
        [-74.011419, 40.740674],
        [-74.011446, 40.740644],
        [-74.012634, 40.740690],
        [-74.012640, 40.740653],
        [-74.012469, 40.740638],
        [-74.012149, 40.740628],
        [-74.012146, 40.740541],
        [-74.011861, 40.740531],
        [-74.011860, 40.740551],
        [-74.011435, 40.740533],
        [-74.011494, 40.739927],
        [-74.011568, 40.739929],
        [-74.011560, 40.740108],
        [-74.012146, 40.740136],
        [-74.012279, 40.740142],
        [-74.012302, 40.740135],
        [-74.012309, 40.740124],
        [-74.012310, 40.740114],
        [-74.012299, 40.740104],
        [-74.012232, 40.740098],
        [-74.012232, 40.740048],
        [-74.012235, 40.740049],
        [-74.012251, 40.739999],
        [-74.012254, 40.739977],
        [-74.012294, 40.739979],
        [-74.012312, 40.739973],
        [-74.012320, 40.739966],
        [-74.012334, 40.739886],
        [-74.012323, 40.739866],
        [-74.012303, 40.739854],
        [-74.012269, 40.739852],
        [-74.012271, 40.739764],
        [-74.012259, 40.739762],
        [-74.012262, 40.739731],
        [-74.012331, 40.739735],
        [-74.012341, 40.739728],
        [-74.012344, 40.739716],
        [-74.012336, 40.739703],
        [-74.012323, 40.739697],
        [-74.012146, 40.739688],
        [-74.011590, 40.739659],
        [-74.011575, 40.739832],
        [-74.011508, 40.739826],
        [-74.011559, 40.739222],
        [-74.011396, 40.739155],
        [-74.010370, 40.739124],
        [-74.010435, 40.738326],
        [-74.011116, 40.738345],
        [-74.011124, 40.738339],
        [-74.011052, 40.738265],
        [-74.011068, 40.738040],
        [-74.010462, 40.738007],
        [-74.010498, 40.737561],
        [-74.010599, 40.736307],
        [-74.010641, 40.736292],
        [-74.010630, 40.736255],
        [-74.010684, 40.736220],
        [-74.010706, 40.736176],
        [-74.010711, 40.736130],
        [-74.010690, 40.736092],
        [-74.010649, 40.736053],
        [-74.010651, 40.736013],
        [-74.010631, 40.736006],
        [-74.010794, 40.734235],
        [-74.011948, 40.734288],
        [-74.011974, 40.734031],
        [-74.011969, 40.734031],
        [-74.011969, 40.734011],
        [-74.010816, 40.733960],
        [-74.010877, 40.733246],
        [-74.013989, 40.733289],
        [-74.013986, 40.733011],
        [-74.010914, 40.732968],
        [-74.011152, 40.730400],
        [-74.013999, 40.730614],
        [-74.014327, 40.728568],
        [-74.014810, 40.728610],
        [-74.014850, 40.728602],
        [-74.014861, 40.728464],
        [-74.013713, 40.728362],
        [-74.013716, 40.728281],
        [-74.013817, 40.728281],
        [-74.013811, 40.728219],
        [-74.013674, 40.728212],
        [-74.013660, 40.728272],
        [-74.013684, 40.728276],
        [-74.013676, 40.728359],
        [-74.011913, 40.728221],
        [-74.011915, 40.728167],
        [-74.012161, 40.728193],
        [-74.012167, 40.728155],
        [-74.011942, 40.728139],
        [-74.011952, 40.728085],
        [-74.011893, 40.728078],
        [-74.011889, 40.728129],
        [-74.011874, 40.728127],
        [-74.011869, 40.728162],
        [-74.011890, 40.728164],
        [-74.011887, 40.728218],
        [-74.011374, 40.728174],
        [-74.011605, 40.725982],
        [-74.011634, 40.725839],
        [-74.011186, 40.725796],
        [-74.010973, 40.725776],
        [-74.010871, 40.725756],
        [-74.010773, 40.725701],
        [-74.010089, 40.725228],
        [-74.009965, 40.725145],
        [-74.009887, 40.725102],
        [-74.009745, 40.725024],
        [-74.009535, 40.724882],
        [-74.009356, 40.724674],
        [-74.007829, 40.723589],
        [-74.006328, 40.722522],
        [-74.005904, 40.722254],
        [-74.005385, 40.721862],
        [-74.005414, 40.722061],
        [-74.005385, 40.722221],
        [-74.005061, 40.722977],
        [-74.004779, 40.723614],
        [-74.004581, 40.724147],
        [-74.001418, 40.731054],
        [-73.997810, 40.736025],
        [-74.001769, 40.737674],
        [-74.002404, 40.738759],
        [-74.003886, 40.738754],
        [-74.003881, 40.739399],
        [-74.004044, 40.739468],
        [-74.004197, 40.739416],
        [-74.006489, 40.739402],
        [-74.006389, 40.739622],
        [-74.008956, 40.740720]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.997811, 40.736024],
        [-74.001419, 40.731052],
        [-74.002770, 40.728517],
        [-74.002876, 40.728291],
        [-73.996825, 40.725372],
        [-73.995389, 40.725021],
        [-73.994954, 40.724859],
        [-73.994317, 40.724651],
        [-73.994206, 40.724653],
        [-73.994080, 40.724629],
        [-73.993480, 40.724405],
        [-73.992687, 40.724128],
        [-73.992556, 40.724088],
        [-73.983844, 40.721437],
        [-73.981309, 40.720672],
        [-73.977252, 40.719276],
        [-73.975086, 40.718788],
        [-73.974742, 40.718771],
        [-73.973597, 40.718600],
        [-73.973142, 40.720132],
        [-73.973070, 40.720143],
        [-73.972208, 40.723757],
        [-73.973494, 40.724136],
        [-73.977531, 40.725829],
        [-73.977300, 40.726135],
        [-73.977103, 40.726459],
        [-73.976644, 40.727086]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.982737, 40.750967],
        [-73.986389, 40.745906],
        [-73.973214, 40.740367],
        [-73.973211, 40.740363],
        [-73.972426, 40.739985],
        [-73.972327, 40.739966],
        [-73.972287, 40.739974],
        [-73.972148, 40.740648],
        [-73.972168, 40.740666],
        [-73.972279, 40.740676],
        [-73.972263, 40.740718],
        [-73.971946, 40.742291],
        [-73.971722, 40.742625],
        [-73.971869, 40.742678],
        [-73.971861, 40.742689],
        [-73.971852, 40.742693],
        [-73.971807, 40.742780],
        [-73.971588, 40.743126],
        [-73.971187, 40.743716],
        [-73.971191, 40.743719],
        [-73.971185, 40.743726],
        [-73.971340, 40.743792],
        [-73.971203, 40.743994],
        [-73.970672, 40.743795],
        [-73.970574, 40.743916],
        [-73.970584, 40.743931],
        [-73.971097, 40.744152],
        [-73.970946, 40.744386],
        [-73.970938, 40.744386],
        [-73.970916, 40.744425],
        [-73.970769, 40.744360],
        [-73.970748, 40.744385],
        [-73.970458, 40.744808],
        [-73.970431, 40.744821],
        [-73.970295, 40.744981],
        [-73.970320, 40.745009],
        [-73.969962, 40.745443],
        [-73.970422, 40.745767],
        [-73.971546, 40.746226],
        [-73.971688, 40.746307],
        [-73.972402, 40.746592],
        [-73.973205, 40.746938]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-74.008654, 40.711347],
        [-74.009100, 40.710862],
        [-74.010578, 40.709105],
        [-74.009690, 40.708715],
        [-74.009432, 40.708574],
        [-74.008312, 40.707671],
        [-74.007436, 40.707167],
        [-74.006820, 40.706688],
        [-74.006739, 40.706611],
        [-74.006599, 40.706505],
        [-74.005638, 40.705787],
        [-74.005558, 40.705746],
        [-74.005462, 40.705697],
        [-74.004776, 40.705184],
        [-74.004331, 40.705078],
        [-74.003904, 40.705354],
        [-74.003789, 40.705265],
        [-74.003269, 40.705593],
        [-74.003252, 40.705572],
        [-74.003242, 40.705578],
        [-74.002134, 40.704580],
        [-74.001920, 40.704711],
        [-74.002277, 40.705028],
        [-74.002239, 40.705068],
        [-74.002653, 40.705416],
        [-74.002518, 40.705492],
        [-74.002110, 40.705323],
        [-74.002024, 40.705380],
        [-74.001410, 40.704828],
        [-74.000529, 40.705387],
        [-74.001372, 40.706137],
        [-74.000939, 40.706382],
        [-74.001156, 40.706606],
        [-74.001121, 40.706626],
        [-74.001197, 40.706704],
        [-74.001097, 40.706756],
        [-74.001094, 40.706772],
        [-74.001148, 40.706815],
        [-74.001129, 40.706838],
        [-74.000366, 40.707218],
        [-73.999974, 40.707430],
        [-73.999916, 40.707485],
        [-73.999866, 40.707582],
        [-73.999644, 40.707677],
        [-73.999203, 40.707945],
        [-74.004103, 40.711784],
        [-74.004341, 40.711772],
        [-74.004598, 40.711841],
        [-74.004880, 40.711990],
        [-74.005255, 40.712047],
        [-74.005934, 40.711911],
        [-74.005934, 40.711911],
        [-74.008648, 40.711341]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-74.002877, 40.728285],
        [-74.003330, 40.727291],
        [-74.003735, 40.726242],
        [-74.004295, 40.724832],
        [-74.004780, 40.723614],
        [-74.005117, 40.722846],
        [-74.005385, 40.722220],
        [-74.005414, 40.722061],
        [-74.005385, 40.721862],
        [-74.005362, 40.721734],
        [-74.004983, 40.721558],
        [-74.004658, 40.721351],
        [-74.001274, 40.718961],
        [-73.999320, 40.717551],
        [-73.999066, 40.717337],
        [-73.998904, 40.717233],
        [-73.998604, 40.717088],
        [-73.997775, 40.716816],
        [-73.996996, 40.716509],
        [-73.995830, 40.716081],
        [-73.995646, 40.715981],
        [-73.995552, 40.715912],
        [-73.995505, 40.715840],
        [-73.995375, 40.715672],
        [-73.995255, 40.715480],
        [-73.993896, 40.713061],
        [-73.993189, 40.711805],
        [-73.991922, 40.709491],
        [-73.991036, 40.709622],
        [-73.990994, 40.709611],
        [-73.990875, 40.709640],
        [-73.990771, 40.709648],
        [-73.989346, 40.709857],
        [-73.989349, 40.709861],
        [-73.988730, 40.709934],
        [-73.988702, 40.709941],
        [-73.988657, 40.709898],
        [-73.988622, 40.709882],
        [-73.988596, 40.709875],
        [-73.988507, 40.709399],
        [-73.988494, 40.709382],
        [-73.988447, 40.709386],
        [-73.988433, 40.709349],
        [-73.988395, 40.709292],
        [-73.988475, 40.709275],
        [-73.988524, 40.709277],
        [-73.988508, 40.709189],
        [-73.988451, 40.709183],
        [-73.988459, 40.709163],
        [-73.988430, 40.709116],
        [-73.988390, 40.709095],
        [-73.988336, 40.709095],
        [-73.986260, 40.709300],
        [-73.986260, 40.709292],
        [-73.985900, 40.709338],
        [-73.985451, 40.709377],
        [-73.985398, 40.709391],
        [-73.985391, 40.709391],
        [-73.985391, 40.709379],
        [-73.981371, 40.709772],
        [-73.981368, 40.709768],
        [-73.981192, 40.709788],
        [-73.981189, 40.709798],
        [-73.981235, 40.710184],
        [-73.981232, 40.710188],
        [-73.981126, 40.710195],
        [-73.981130, 40.710197],
        [-73.981130, 40.710219],
        [-73.981114, 40.710221],
        [-73.981109, 40.710195],
        [-73.980283, 40.710252],
        [-73.980275, 40.710313],
        [-73.980251, 40.710329],
        [-73.978618, 40.710441],
        [-73.978222, 40.710455],
        [-73.977976, 40.710511],
        [-73.977851, 40.710561],
        [-73.977096, 40.711091],
        [-73.976784, 40.711365],
        [-73.976428, 40.711797],
        [-73.974553, 40.715775],
        [-73.974519, 40.715920],
        [-73.974275, 40.716544],
        [-73.974245, 40.716550],
        [-73.973566, 40.718697],
        [-73.974741, 40.718789],
        [-73.975084, 40.718805],
        [-73.975448, 40.718902],
        [-73.977243, 40.719265],
        [-73.978757, 40.719874],
        [-73.981315, 40.720665],
        [-73.992687, 40.724129],
        [-73.994207, 40.724655],
        [-73.994317, 40.724659],
        [-73.994492, 40.724701],
        [-73.995524, 40.725063],
        [-73.995772, 40.725120],
        [-73.995921, 40.725204],
        [-73.997002, 40.725468],
        [-74.002689, 40.728251]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-74.011632, 40.725839],
        [-74.011808, 40.724942],
        [-74.011824, 40.724935],
        [-74.011864, 40.724719],
        [-74.011851, 40.724716],
        [-74.011988, 40.724430],
        [-74.012001, 40.724364],
        [-74.012570, 40.721471],
        [-74.013133, 40.721522],
        [-74.013189, 40.721225],
        [-74.015660, 40.721516],
        [-74.015729, 40.721188],
        [-74.012929, 40.720848],
        [-74.013040, 40.720304],
        [-74.016271, 40.720699],
        [-74.016347, 40.720696],
        [-74.016419, 40.720362],
        [-74.013452, 40.719998],
        [-74.013484, 40.719792],
        [-74.012960, 40.719715],
        [-74.013266, 40.718318],
        [-74.013281, 40.718307],
        [-74.015000, 40.718525],
        [-74.015033, 40.718519],
        [-74.015051, 40.718487],
        [-74.015052, 40.718447],
        [-74.015075, 40.718428],
        [-74.015184, 40.718446],
        [-74.016695, 40.718644],
        [-74.016714, 40.718641],
        [-74.016731, 40.718637],
        [-74.016754, 40.718617],
        [-74.016760, 40.718602],
        [-74.016768, 40.718527],
        [-74.016958, 40.717549],
        [-74.016877, 40.717516],
        [-74.017071, 40.716462],
        [-74.017268, 40.716485],
        [-74.017252, 40.716610],
        [-74.017392, 40.716626],
        [-74.017448, 40.716315],
        [-74.017308, 40.716298],
        [-74.017281, 40.716424],
        [-74.017081, 40.716406],
        [-74.016485, 40.716275],
        [-74.014699, 40.715504],
        [-74.014184, 40.715365],
        [-74.013732, 40.715285],
        [-74.013116, 40.715155],
        [-74.011982, 40.714982],
        [-74.011337, 40.714892],
        [-74.008864, 40.713762],
        [-74.006717, 40.716501],
        [-74.005361, 40.718235],
        [-74.005271, 40.718302],
        [-74.003516, 40.720521],
        [-74.004657, 40.721351],
        [-74.004984, 40.721560],
        [-74.005385, 40.721861],
        [-74.005901, 40.722251],
        [-74.007828, 40.723589],
        [-74.007975, 40.723759],
        [-74.008667, 40.724260],
        [-74.008920, 40.724425],
        [-74.009094, 40.724502],
        [-74.009354, 40.724673],
        [-74.009449, 40.724779],
        [-74.009535, 40.724882],
        [-74.009743, 40.725025],
        [-74.009963, 40.725144],
        [-74.010777, 40.725703],
        [-74.010873, 40.725757],
        [-74.010973, 40.725776],
        [-74.011186, 40.725798]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-74.001335, 40.762085],
        [-74.001862, 40.762154],
        [-74.001832, 40.762131],
        [-74.002174, 40.761698],
        [-74.004274, 40.762604],
        [-74.004286, 40.762590],
        [-74.004408, 40.762635],
        [-74.004547, 40.762453],
        [-74.002339, 40.761518],
        [-74.002759, 40.760885],
        [-74.003085, 40.761028],
        [-74.003089, 40.761022],
        [-74.003112, 40.761032],
        [-74.003371, 40.760697],
        [-74.003592, 40.760787],
        [-74.003527, 40.760890],
        [-74.003611, 40.760920],
        [-74.004164, 40.760186],
        [-74.004066, 40.760147],
        [-74.003987, 40.760242],
        [-74.003785, 40.760155],
        [-74.003925, 40.759958],
        [-74.003572, 40.759806],
        [-74.003545, 40.759849],
        [-74.003533, 40.759841],
        [-74.003566, 40.759800],
        [-74.003555, 40.759795],
        [-74.003595, 40.759740],
        [-74.003597, 40.759741],
        [-74.003657, 40.759660],
        [-74.004012, 40.759813],
        [-74.004014, 40.759822],
        [-74.004017, 40.759819],
        [-74.004091, 40.759843],
        [-74.004555, 40.760049],
        [-74.004592, 40.759993],
        [-74.004140, 40.759787],
        [-74.004231, 40.759646],
        [-74.004101, 40.759591],
        [-74.004097, 40.759601],
        [-74.004075, 40.759590],
        [-74.004484, 40.759037],
        [-74.006429, 40.759850],
        [-74.006476, 40.759850],
        [-74.006930, 40.759264],
        [-74.006975, 40.759188],
        [-74.006980, 40.759159],
        [-74.006975, 40.759135],
        [-74.005013, 40.758304],
        [-74.005245, 40.757983],
        [-74.005242, 40.757967],
        [-74.004982, 40.757847],
        [-74.004953, 40.757810],
        [-74.004928, 40.757790],
        [-74.004901, 40.757775],
        [-74.004891, 40.757739],
        [-74.004866, 40.757689],
        [-74.004875, 40.757652],
        [-74.005160, 40.757241],
        [-74.005190, 40.757243],
        [-74.005222, 40.757261],
        [-74.005239, 40.757259],
        [-74.005274, 40.757247],
        [-74.005307, 40.757247],
        [-74.005337, 40.757241],
        [-74.005366, 40.757291],
        [-74.005400, 40.757262],
        [-74.005805, 40.756691],
        [-74.005821, 40.756683],
        [-74.007122, 40.754887],
        [-74.007246, 40.754938],
        [-74.007358, 40.754780],
        [-74.007394, 40.754745],
        [-74.007269, 40.754690],
        [-74.006986, 40.754621],
        [-74.006866, 40.754564],
        [-74.006637, 40.754446],
        [-74.006556, 40.754410],
        [-73.986390, 40.745906],
        [-73.980894, 40.753488],
        [-73.986946, 40.756032],
        [-73.987893, 40.754751],
        [-73.993589, 40.757154],
        [-73.992642, 40.758424],
        [-74.001058, 40.761940]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.997390, 40.766810],
        [-73.997995, 40.765948],
        [-74.001236, 40.767297],
        [-74.001294, 40.767305],
        [-74.001624, 40.766865],
        [-74.001605, 40.766814],
        [-74.001506, 40.766747],
        [-74.001455, 40.766719],
        [-73.998332, 40.765392],
        [-73.998410, 40.765290],
        [-73.998580, 40.765226],
        [-73.998681, 40.765160],
        [-73.998697, 40.765094],
        [-73.998652, 40.765043],
        [-73.998555, 40.765015],
        [-73.998491, 40.765027],
        [-73.998514, 40.764994],
        [-73.998541, 40.764988],
        [-73.998534, 40.764981],
        [-73.998533, 40.764971],
        [-73.998864, 40.764520],
        [-74.001998, 40.765849],
        [-74.002006, 40.765858],
        [-74.002300, 40.765533],
        [-74.002265, 40.765516],
        [-74.002275, 40.765507],
        [-74.002279, 40.765482],
        [-73.999208, 40.764194],
        [-73.999183, 40.764190],
        [-73.999188, 40.764182],
        [-73.999140, 40.764161],
        [-73.999522, 40.763625],
        [-73.999529, 40.763627],
        [-73.999529, 40.763609],
        [-73.999591, 40.763523],
        [-73.999602, 40.763521],
        [-73.999794, 40.763426],
        [-73.999800, 40.763417],
        [-73.999806, 40.763419],
        [-73.999904, 40.763360],
        [-74.002939, 40.764637],
        [-74.002944, 40.764646],
        [-74.003098, 40.764707],
        [-74.003132, 40.764697],
        [-74.003201, 40.764612],
        [-74.003163, 40.764570],
        [-74.003132, 40.764560],
        [-74.003090, 40.764600],
        [-74.003048, 40.764606],
        [-74.003008, 40.764598],
        [-74.002981, 40.764584],
        [-74.002981, 40.764580],
        [-74.002933, 40.764559],
        [-74.003098, 40.764331],
        [-74.003104, 40.764329],
        [-74.003096, 40.764325],
        [-74.003102, 40.764325],
        [-74.003120, 40.764289],
        [-74.000940, 40.763375],
        [-74.001362, 40.762785],
        [-74.003520, 40.763693],
        [-74.003523, 40.763686],
        [-74.003529, 40.763697],
        [-74.003609, 40.763730],
        [-74.003754, 40.763548],
        [-74.003659, 40.763497],
        [-74.003665, 40.763491],
        [-74.003654, 40.763491],
        [-74.001534, 40.762599],
        [-74.001549, 40.762592],
        [-74.001537, 40.762586],
        [-74.001863, 40.762154],
        [-74.001334, 40.762085],
        [-74.001058, 40.761940],
        [-73.998366, 40.760801],
        [-73.992642, 40.758424],
        [-73.993588, 40.757155],
        [-73.987893, 40.754751],
        [-73.986947, 40.756031],
        [-73.984126, 40.754852],
        [-73.980894, 40.753489],
        [-73.978565, 40.756659],
        [-73.981808, 40.758025],
        [-73.980442, 40.759888],
        [-73.996882, 40.766834]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-73.969433, 40.753632],
        [-73.974050, 40.747294],
        [-73.971689, 40.746307],
        [-73.971546, 40.746227],
        [-73.970423, 40.745767],
        [-73.969961, 40.745443],
        [-73.969838, 40.745416],
        [-73.969055, 40.746400],
        [-73.968952, 40.746489],
        [-73.968912, 40.746485],
        [-73.968221, 40.747330],
        [-73.968348, 40.747393],
        [-73.967899, 40.747915],
        [-73.967402, 40.748512],
        [-73.967409, 40.748517],
        [-73.967140, 40.748826],
        [-73.967110, 40.748870],
        [-73.967075, 40.748898],
        [-73.967003, 40.749003],
        [-73.966842, 40.749177],
        [-73.966845, 40.749185],
        [-73.966028, 40.750178],
        [-73.964219, 40.752191],
        [-73.964865, 40.752505],
        [-73.965139, 40.752627],
        [-73.966617, 40.753246],
        [-73.968981, 40.754252]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.x_arr = [
        [-74.017081, 40.716406],
        [-74.017398, 40.714718],
        [-74.017602, 40.713519],
        [-74.017599, 40.713519],
        [-74.017693, 40.713031],
        [-74.017663, 40.713017],
        [-74.017630, 40.713031],
        [-74.017538, 40.713564],
        [-74.017202, 40.713504],
        [-74.017218, 40.713422],
        [-74.017234, 40.713424],
        [-74.017293, 40.713253],
        [-74.017220, 40.713239],
        [-74.017171, 40.713417],
        [-74.017193, 40.713421],
        [-74.017185, 40.713456],
        [-74.017182, 40.713456],
        [-74.017185, 40.713457],
        [-74.017176, 40.713501],
        [-74.016936, 40.713462],
        [-74.016950, 40.713392],
        [-74.016971, 40.713390],
        [-74.017012, 40.713210],
        [-74.016970, 40.713204],
        [-74.016919, 40.713382],
        [-74.016935, 40.713388],
        [-74.016919, 40.713458],
        [-74.016320, 40.713377],
        [-74.016405, 40.713087],
        [-74.016524, 40.712953],
        [-74.016561, 40.712897],
        [-74.016596, 40.712826],
        [-74.016599, 40.712809],
        [-74.016602, 40.712810],
        [-74.016629, 40.712640],
        [-74.016621, 40.712581],
        [-74.016556, 40.712424],
        [-74.016615, 40.712170],
        [-74.016800, 40.712188],
        [-74.016813, 40.712176],
        [-74.016856, 40.712180],
        [-74.016865, 40.712168],
        [-74.016983, 40.712191],
        [-74.016972, 40.712238],
        [-74.016948, 40.712240],
        [-74.016894, 40.712646],
        [-74.016926, 40.712652],
        [-74.016966, 40.712378],
        [-74.016975, 40.712375],
        [-74.017004, 40.712190],
        [-74.017190, 40.712222],
        [-74.017168, 40.712303],
        [-74.017155, 40.712301],
        [-74.017115, 40.712463],
        [-74.017159, 40.712469],
        [-74.017213, 40.712227],
        [-74.017504, 40.712275],
        [-74.017490, 40.712344],
        [-74.017472, 40.712344],
        [-74.017415, 40.712517],
        [-74.017471, 40.712532],
        [-74.017537, 40.712354],
        [-74.017513, 40.712350],
        [-74.017527, 40.712282],
        [-74.017640, 40.712298],
        [-74.017640, 40.712296],
        [-74.017767, 40.712315],
        [-74.017686, 40.712755],
        [-74.017738, 40.712758],
        [-74.017905, 40.711874],
        [-74.017907, 40.711874],
        [-74.017934, 40.711727],
        [-74.017940, 40.711727],
        [-74.017942, 40.711664],
        [-74.017958, 40.711558],
        [-74.017976, 40.711440],
        [-74.017984, 40.711394],
        [-74.017989, 40.711358],
        [-74.018010, 40.711267],
        [-74.018017, 40.711250],
        [-74.018023, 40.711191],
        [-74.018101, 40.710855],
        [-74.018123, 40.710801],
        [-74.018138, 40.710693],
        [-74.018167, 40.710562],
        [-74.018174, 40.710531],
        [-74.018241, 40.710312],
        [-74.018366, 40.709792],
        [-74.018377, 40.709737],
        [-74.018418, 40.709621],
        [-74.018428, 40.709576],
        [-74.018438, 40.709514],
        [-74.018810, 40.708004],
        [-74.018799, 40.707980],
        [-74.018785, 40.707968],
        [-74.018766, 40.707958],
        [-74.018670, 40.707925],
        [-74.018613, 40.707917],
        [-74.018619, 40.707905],
        [-74.018151, 40.707781],
        [-74.018487, 40.706906],
        [-74.018523, 40.706911],
        [-74.018555, 40.706933],
        [-74.018581, 40.706979],
        [-74.018589, 40.706983],
        [-74.018637, 40.706984],
        [-74.018662, 40.706974],
        [-74.018701, 40.706971],
        [-74.018731, 40.706963],
        [-74.018758, 40.706949],
        [-74.018774, 40.706931],
        [-74.018808, 40.706939],
        [-74.018800, 40.706953],
        [-74.018803, 40.706955],
        [-74.018764, 40.706992],
        [-74.018706, 40.707018],
        [-74.018719, 40.707034],
        [-74.018716, 40.707047],
        [-74.018662, 40.707053],
        [-74.018609, 40.707050],
        [-74.018595, 40.707107],
        [-74.018673, 40.707108],
        [-74.018758, 40.707093],
        [-74.018797, 40.707078],
        [-74.018863, 40.707034],
        [-74.018881, 40.707015],
        [-74.018909, 40.706973],
        [-74.019010, 40.706992],
        [-74.019063, 40.706971],
        [-74.019077, 40.706956],
        [-74.019096, 40.706913],
        [-74.019106, 40.706874],
        [-74.019120, 40.706752],
        [-74.019150, 40.706692],
        [-74.019161, 40.706651],
        [-74.019174, 40.706551],
        [-74.019190, 40.706491],
        [-74.019211, 40.706377],
        [-74.019245, 40.706269],
        [-74.019291, 40.706060],
        [-74.019286, 40.706021],
        [-74.019115, 40.705488],
        [-74.019088, 40.705363],
        [-74.019055, 40.705300],
        [-74.018870, 40.704731],
        [-74.018849, 40.704711],
        [-74.018806, 40.704691],
        [-74.018745, 40.704670],
        [-74.018640, 40.704650],
        [-74.018537, 40.704619],
        [-74.018260, 40.704573],
        [-74.018200, 40.704560],
        [-74.018143, 40.704555],
        [-74.018152, 40.704530],
        [-74.018139, 40.704518],
        [-74.018082, 40.704514],
        [-74.018062, 40.704515],
        [-74.018058, 40.704524],
        [-74.018039, 40.704523],
        [-74.018026, 40.704531],
        [-74.018030, 40.704544],
        [-74.018051, 40.704547],
        [-74.018048, 40.704563],
        [-74.018031, 40.704571],
        [-74.018024, 40.704595],
        [-74.018013, 40.704601],
        [-74.017516, 40.704652],
        [-74.017484, 40.704702],
        [-74.017358, 40.704855],
        [-74.017181, 40.704805],
        [-74.017103, 40.704790],
        [-74.016984, 40.704783],
        [-74.016834, 40.704780],
        [-74.016743, 40.704752],
        [-74.016666, 40.704741],
        [-74.016380, 40.704753],
        [-74.015957, 40.704788],
        [-74.015702, 40.704796],
        [-74.015574, 40.704781],
        [-74.015366, 40.704749],
        [-74.015043, 40.704690],
        [-74.014645, 40.704594],
        [-74.014486, 40.704544],
        [-74.014349, 40.704514],
        [-74.014169, 40.704668],
        [-74.014085, 40.704830],
        [-74.013914, 40.705099],
        [-74.013826, 40.705220],
        [-74.013385, 40.705749],
        [-74.013295, 40.705821],
        [-74.011109, 40.708566],
        [-74.010578, 40.709104],
        [-74.009099, 40.710863],
        [-74.009055, 40.710910],
        [-74.008655, 40.711347],
        [-74.010163, 40.712054],
        [-74.010121, 40.712133],
        [-74.009701, 40.712692],
        [-74.009616, 40.712797],
        [-74.008864, 40.713763],
        [-74.011338, 40.714892],
        [-74.013115, 40.715155],
        [-74.014176, 40.715364],
        [-74.014207, 40.715372],
        [-74.014700, 40.715505],
        [-74.016484, 40.716274]
    ];
    $scope.clusters2.push($scope.x_arr);

    $scope.update_clusters2__fn = function (indexNum) {
        var features_arr = [];
        var indexNum2 = $scope.clusters2_indexes.indexOf(indexNum);
        if (indexNum2 < 0) {
            $scope.clusters2_indexes.push(indexNum);
        } else {
            $scope.clusters2_indexes.splice(indexNum2, 1);
        }

        //dynamically adds or removes clusters2 to FeatureColllection
        angular.forEach($scope.clusters2_indexes, function (value) {
            var jsonn_feature = {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        $scope.clusters2[value]
                    ]
                }
            };
            features_arr.push(jsonn_feature);
        });

        $scope.geojson.data = {
            "type": "FeatureColllection",
            "features": features_arr
        };
    };

    //////////////////////////////
    //2019-03-23
    var tilesDict = {
        openstreetmap: {
            url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            options: {
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }
        },
        opencyclemap: {
            url: 'https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=153aaa3e51d4422390e5a03f4b77985d',
            //url: "http://{s}.tile.opencyclemap.org/cycle/{z}/{x}/{y}.png",
            options: {
                attribution: 'All maps &copy; <a href="http://www.opencyclemap.org">OpenCycleMap</a>, map data &copy; <a href="http://www.openstreetmap.org">OpenStreetMap</a> (<a href="http://www.openstreetmap.org/copyright">ODbL</a>'
            }
        },
        // 2019-04-28 homepage
        mapbox1: {
            //url: 'https://api.mapbox.com/styles/v1/{styleID}/tiles/{z}/{x}/{y}?access_token={apikey}',
            url: 'https://api.mapbox.com/styles/v1/{styleID}/tiles/256/{z}/{x}/{y}?access_token={apikey}',

            //url: 'https://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
            options: {
                apikey: 'pk.eyJ1Ijoib3B0aW1hbHNwYWNlcyIsImEiOiJjanJvNXhqeGkwNmJlNDlwM2xhdmZkcjZ3In0.uGIEwuw8h0jkPB1g2gtmXg',
                styleID: 'optimalspaces/cjtmdur6oca5w1fpi98zk7kzg'
            }
        },


    };
    //2019-03-23
    //very sure below logic is 100% easier but have 0 time for it.
    $scope.clusters = [];
    $scope.clusters_indexes = [];
    $scope.midtown = [
        [-73.99601, 40.774432],
        [-74.009228, 40.758961],
        [-73.970776, 40.74212],
        [-73.956442, 40.757725],
        [-73.99601, 40.774432],
        [-73.99601, 40.774432]
    ];
    $scope.clusters.push($scope.midtown);
    $scope.midtown_south_arr = [
        [-73.979702, 40.710182],
        [-73.974895, 40.710573],
        [-73.971806, 40.71877],
        [-73.968716, 40.727226],
        [-73.971119, 40.732039],
        [-73.970776, 40.74212],
        [-74.009228, 40.758961],
        [-74.016352, 40.729893],
        [-74.00116, 40.718315],
        [-73.979702, 40.710182]
    ];
    $scope.clusters.push($scope.midtown_south_arr);
    $scope.downtown_arr = [
        [-74.016352, 40.729893],
        [-74.020901, 40.701334],
        [-74.013519, 40.69821],
        [-73.989487, 40.70797],
        [-73.979702, 40.710182],
        [-74.00116, 40.718315],
        [-74.016352, 40.729893]
    ];
    $scope.clusters.push($scope.downtown_arr);
    $scope.update_clusters__fn = function (indexNum) {
        var features_arr = [];
        var indexNum2 = $scope.clusters_indexes.indexOf(indexNum);
        if (indexNum2 < 0) {
            $scope.clusters_indexes.push(indexNum);
        } else {
            $scope.clusters_indexes.splice(indexNum2, 1);
        }

        //dynamically adds or removes clusters to FeatureColllection
        angular.forEach($scope.clusters_indexes, function (value) {
            var jsonn_feature = {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        $scope.clusters[value]
                    ]
                }
            };
            features_arr.push(jsonn_feature);
        });

        $scope.geojson.data = {
            "type": "FeatureColllection",
            "features": features_arr
        };

        /*20190428 04-28         aqui poner markers */
        // marcadorFactory.query({'q': $scope.q}).$promise.then(function(data) {
        //         $scope.markers = data.markers;
        // });


    };

    //2019-04-28
    $scope.$root.gmarker_window2_clicked2 = function (marker_index) {
        marker_index -= 1; // trick
        $scope.this_marker = $scope.markers[marker_index];
        ////console.log($scope.this_marker);
        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });;

        ////console.log($scope.this_marker);
        $scope.submission.needs = 're ' + $scope.this_marker.address + ' ';
        $scope.find_my_space(1);


    };



    //2019-09-18
    $scope.$root.gmarker_window2_clicked3 = function (marker_index) {
        //marker_index             -= 1; // trick
        $scope.this_marker = $scope.markers[marker_index];
        ////console.log($scope.this_marker);
        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });;

        ////console.log($scope.this_marker);
        //$scope.submission.needs = 're ' + $scope.this_marker.address  + ' ';
        $scope.submission.needs = 're ' + $scope.submission.intended_use_str + ' listing id # ' + $scope.this_marker.listing_id;

        $scope.find_my_space(1);


    };







    //963 line
    //2019-02-02 homepage CTrl
    $scope.center = {
        lng: -73.9825724,
        /* X */
        /* 2019-04- 28 */
        lat: 40.74999,
        /* Y */
        /* 2019-04- 28 */
        zoom: 13,
    };




    //2019-04-28
    angular.extend($scope, {
        center: {
            lat: 40.74999,
            /* Y */
            /* 2019-04- 28 */
            lng: -73.9825724,
            /* X */
            /* 2019-04- 28 */
            zoom: 13,
        },
        tiles: tilesDict.mapbox1,
        geojson: {
            data: {
                "type": "FeatureCollection",
                "features": [{
                    "id": "midtown_south",
                    "type": "Feature",
                    "properties": {},
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [
                            []
                        ]
                    }
                }]
            },
            style: {
                fillColor: "#1a837a",
                weight: 2,
                opacity: 1,
                color: '#1a837a',
                dashArray: '3',
                fillOpacity: 0.5
            },
        },

    });


    // //2019-04-28
    // // for now same as in excecutive landing page
    // // 777 is dummy landing page that don't exists but necessary to view work
    // // 1234567 is dummy
    // marcadorFactory.query({'q': '1234567:office:700:777'}).$promise.then(function(data) {
    //     $scope.markers = data.markers;
    // });






    $scope.cursor_str = '';
    $(window).bind('hashchange', function () {
        var hash = window.location.hash.slice(1);
        $scope.cursor_str = hash;

    });


    $scope.testimonials_interval = 1500;
    $timeout(function () {
        $scope.testimonials_interval = 3500;
    }, 4500); /* 4 slices x 1500 */

    $scope.noWrapSlides = false;
    $scope.active = 0;
    var currIndex = 0;
    $scope.educational_slides = [{
            id: 0,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/education_logos/education_logos_1.png',
            alt: 'NYC Educational Lease Clients',
        },
        {
            id: 1,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/education_logos/education_logos_2.png',
            alt: 'New York School Lease Clients',
        },


    ];


    $scope.technology_slides = [{
            id: 0,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/technology_logos/technology_logos_1.png',
            alt: 'NYC technology Lease Clients',
        },
        {
            id: 1,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/technology_logos/technology_logos_2.png',
            alt: 'New York technology Lease Clients',
        },
        {
            id: 2,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/technology_logos/technology_logos_3.png',
            alt: 'NYC Legal Lease Clients',
        },

    ];


    $scope.legal_slides = [{
            id: 0,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/legal_logos/legal_logos_1.png',
            alt: 'NYC Legal Lease Clients',
        },
        {
            id: 1,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/legal_logos/legal_logos_2.png',
            alt: 'New York Legal Lease Clients',
        },

    ];

    $scope.financial_slides = [{
            id: 0,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/financial_logos/financial_logos_1.png',
            alt: 'NYC Financial Lease Clients',
        },
        {
            id: 1,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/financial_logos/financial_logos_2.png',
            alt: 'New York Financial Lease Clients',
        },
        {
            id: 2,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/financial_logos/financial_logos_3.png',
            alt: 'Manhattan Financial Lease Clients',
        },
        {
            id: 3,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/financial_logos/financial_logos_4.png',
            alt: 'NY USA Financial Lease Clients',
        },
    ];


    $scope.office_slides = [{
            id: 0,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_1.png',
            alt: 'NYC Office Lease Clients',
        },
        {
            id: 1,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_2.png',
            alt: 'New York Office Lease Clients',
        },
        {
            id: 2,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_3.png',
            alt: 'Manhattan Office Lease Clients',
        },
        {
            id: 3,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_4.png',
            alt: 'NY USA Office Lease Clients',
        },
        {
            id: 4,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_5.png',
            alt: 'Office Lease Clients New York',
        },
        {
            id: 5,
            image: 'https://www.optimalspaces.com/images/logos_testimonials/office_logos/office_logos_6.png',
            alt: 'NY USA Office Lease Clients NYC',
        },
    ];

    $scope.notify_me = function (page_id) {

        unico.notify_me(page_id, $scope.form);
    };

    //2017-05-19 added
    $scope.find_my_space = function (page_id) {
        unico.find_my_space(page_id);
    };

    //2018-10-01 added
    $scope.searching_now_on = false;

    $scope.progress_number = 50;
    $scope.progress_bar_move = function () {
        var elem = document.getElementById("progressbar");
        //var width = 10;

        var id = setInterval(frame, 10);

        function frame() {
            if ($scope.progress_number >= 100) {
                clearInterval(id);
            } else {
                $scope.progress_number++;
                ////console.log($scope.progress_number);
                //elem.style.width = width + '%';
                //elem.innerHTML = width * 1 + '%';
            }
        }
    }

    //2017-06-18 added
    $scope.find_search_bar_fn = function (page_id) {
        $scope.searching_now_on = true;

        if ((!($scope.intended_use_str)) && ($scope.btn == 1)) {
            $scope.submission.intended_use_str = 'Office';
        }

        if ($scope.btn > 1) {
            unico.find_my_space(page_id);
        } else {

            $scope.progress_bar_move();
            $scope.submitted = true;


            if ($scope.form.query_name_form.$valid) {
                //unico.search_results(page_id);

                //2018-10-01
                var obj = {
                    'q': $scope.submission.query_name,
                    'm': 0,
                    'ga': readCookie('_ga')
                };

                searchResultsFactory.query(obj).$promise.then(function (data) {
                    $scope.search_results = data.info;

                    if (data.len == 1) {
                        window.location = 'https://www.optimalspaces.com/new-york/' + data.info[0].zipcode + '/' + data.info[0].url;
                    } else {
                        unico.search_results(page_id);
                    }
                });


            }
        }

    };



    // $scope.contact_us_building_sales = function (page_id, type_of_use) {
    //     unico.contact_us_building_sales(page_id, type_of_use);
    // };


    $scope.contact_us = function (page_id) {
        unico.contact_us(page_id);
    };
 

    $scope.download_report = function (pdf_issue) {
        unico.download_report(pdf_issue);
    };

    //homepage selections
    $scope.selectedItems = [];
    $scope.multiform = 0;
    $scope.$watch('multiform', function (new_value, old_value) {
        if (new_value) {
            if (new_value == 4) {

                //dynamically adds or removes clusters to FeatureColllection
                //2019-03-24
                $scope.geojson.data = {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "Polygon",
                            "coordinates": [
                                []
                            ]
                        }
                    }]
                };

                //2019-03-24 added
                //2019-02-09 this prevents the glitch or partial map
                leafletData.getMap('map_advanced').then(function (map) {
                    $timeout(function () {
                        map.invalidateSize();
                    });
                });

                //2019-03-24
                //$timeout(function() {
                //init(); this uses pulsar/fusion/fusion_coords.js
                //}, 100);
            }

            if (new_value == 3) {
                //2019-03-23 added

                $scope.center = {
                    lng: -73.9825724,
                    /* X */
                    /* 2019-04- 28 */
                    lat: 40.74999,
                    /* Y */
                    /* 2019-04- 28 */
                    zoom: 13
                };



                //2019-02-09 this prevents the glitch or partial map
                leafletData.getMap('map_basic').then(function (map) {
                    $timeout(function () {
                        map.invalidateSize();
                    });
                });

                //goodbye google maps
                //$timeout(function() {
                //init_3_submarket_clusters();
                //}, 100);
            }

        }

    });


    //$scope.myInterval   = 2500;
    $scope.noWrapSlides = false;
    $scope.active = 0;
    var currIndex = 0;
    var slides = $scope.slides = [{
            id: 0,
            image: 'images3/slides/slide1.jpg',
        },
        {
            id: 1,
            image: 'images3/slides/slide2.jpg',
        },

    ];

    $scope.map = {
        center: {
            latitude: 45,
            longitude: -73
        },
        zoom: 8
    };


    $scope.currentIndex = 1;
    $scope.next_carousel_screen = function () {
        $scope.multiform = 1;
        $scope.currentIndex = 3;
    };
    $(document).ready(function () {
        $('.city_select_box .dropdown-toggle').click(function (e) {
            $("#section0").toggleClass("city_select_open");
        });
        $(document).on("click", function (e) {
            if ($(e.target).is(".city_select_box .dropdown-toggle") === false) {
                $("#section0").removeClass("city_select_open");
            }
        });
        $('#quote-carousel').bind('slide.bs.carousel', function (e) {
            if ($scope.currentIndex % 3 == 0) {}
            $scope.currentIndex++;
            if ($scope.currentIndex == 3) {
                $scope.multiform = 3;
                $timeout(function () {
                    init();
                }, 100);

            } else {
                $scope.next_screen();
            }
        });

    });

    $scope.listItems = [{
        name: "Midtown",
        id: 0
    }, {
        name: "Midtown South",
        id: 2
    }, {
        name: "Downtown",
        id: 3
    }];

    $scope.cities = [{
            id: 1,
            name: "Manhattan"
        },
        {
            id: 2,
            name: "Brooklyn"
        },
        {
            id: 3,
            name: "Queens"
        },
        {
            id: 4,
            name: "Staten Island"
        },
        {
            id: 5,
            name: "Bronx"
        },
        {
            id: 6,
            name: "Washington, DC"
        },
        {
            id: 7,
            name: "Florida"
        },
        {
            id: 8,
            name: "San Francisco"
        },
        {
            id: 9,
            name: "Other"
        },
    ];

    $scope.obj = {
        'city': $scope.cities[0],
        'size': ''
    };
    $scope.select_city = function (city) {
        $scope.obj.city = city;
    }

    $scope.find_my_space = function (page_id) {
        unico.find_my_space(page_id);

    };

    $scope.next_screen = function (type_of_use) {
        if (type_of_use) {
            //2020-04-11

            if (type_of_use == 'Office') $scope.submission.intended_use_id = 1;
            else if (type_of_use == 'Retail') $scope.submission.intended_use_id = 2;
            else if (type_of_use == 'Educational') $scope.submission.intended_use_id = 6;

            $scope.submission.intended_use_str = type_of_use;
            $scope.multiform = 3;
            $scope.markers = [];

            $scope.total_midtown_spaces = 1400;
            $scope.total_midtown_south_spaces = 567;
            $scope.total_downtown_spaces = 385;

            //2019-09-18
            marcadorFactory.query({
                'option': 'h_' + type_of_use.toLowerCase()
            }).$promise.then(function (data) {
                $scope.markers = data.markers;

                $scope.total_midtown_spaces = data.total_midtown_spaces;
                $scope.total_midtown_south_spaces = data.total_midtown_south_spaces;
                $scope.total_downtown_spaces = data.total_downtown_spaces;

            });
        }
    };

    //2019-09-18
    $scope.next_screen2 = function (type_of_use) {
        if (type_of_use) {
            $scope.submission.intended_use_str = type_of_use;
            $scope.multiform = 1;
        }
    };
    //2019-03-09
    $scope.find_my_space_str = "FIND MY OFFICE SPACE!";
    $scope.btn = 1;
    $scope.type_of_use_fn = function (type_of_use) {
        if (type_of_use) {
            $scope.submission.intended_use_str = type_of_use;
            if (type_of_use == 'Office') {
                $scope.btn = 1;
                $scope.find_my_space_str = "FIND MY OFFICE SPACE!";
            }
            if (type_of_use == 'Retail') {
                $scope.btn = 2;
                $scope.find_my_space_str = "FIND MY RETAIL SPACE!";
            }
            if (type_of_use == 'Educational') {
                $scope.btn = 4;
                $scope.find_my_space_str = "FIND MY EDUCATIONAL SPACE!";
            }
            if (type_of_use == 'Other') {
                $scope.btn = 4;
                $scope.find_my_space_str = "FIND MY OTHER SPACE!";
            }
        }
    };

    $scope.contact_us_map = {
        center: {
            latitude: 40.7521967,
            longitude: -73.985125
        },
        zoom: 16,
        bounds: {},
        options: {
            zoomControl: true,
            minZoom: 13,
            maxZoom: 20,
            mapTypeControl: false,
            streetViewControl: true,
            draggable: true,
            panControl: false,
            optimized: true,
            mapTypeId: 'roadmap',
            styles: [{
                    featureType: "poi",
                    stylers: [{
                        visibility: "on"
                    }]
                },
                {
                    featureType: "poi.park",
                    stylers: [{
                        visibility: "simplified"
                    }]
                },
                {
                    featureType: "road",
                    stylers: [{
                        visibility: "simplified"
                    }]
                },
                {
                    featureType: "transit",
                    stylers: [{
                        visibility: "on"
                    }]
                },
                {
                    featureType: "landscape",
                    stylers: [{
                        visibility: "simplified"
                    }]
                },
                {
                    featureType: "road.highway",
                    stylers: [{
                        visibility: "off"
                    }]
                },
                {
                    featureType: "road.local",
                    stylers: [{
                        visibility: "on"
                    }]
                },
                {
                    featureType: "road.highway",
                    "elementType": "geometry",
                    stylers: [{
                        visibility: "on"
                    }]
                },
                {
                    featureType: "road.arterial",
                    stylers: [{
                        visibility: "on"
                    }]
                },
                {
                    featureType: "water",
                    stylers: [{
                        "color": "#B3D1FF"
                    }]
                },
                {
                    featureType: "road.highway",
                    stylers: [{
                        "weight": 0.36
                    }, {
                        "saturation": -25
                    }, {
                        "lightness": 31
                    }]
                },
                {
                    featureType: "road"
                },
                //{featureType: "landscape",        stylers: [          {            "hue": "#0066ff"          },          {            "saturation": 74          },          {"lightness": 100}]}
            ]
        }
    };

    $scope.contact_us_marker = {
        id: 0,
        coords: {
            latitude: 40.7521967,
            longitude: -73.985125
        },
        options: {
            draggable: true
        },
        events: {
            dragend: function (marker, eventName, args) {
                $log.log('marker dragend');
                var lat = marker.getPosition().lat();
                var lon = marker.getPosition().lng();
                $log.log(lat);
                $log.log(lon);

                $scope.contact_us_marker.options = {
                    draggable: true,
                    labelContent: "lat: " + $scope.contact_us_marker.coords.latitude + ' ' + 'lon: ' + $scope.contact_us_marker.coords.longitude,
                    labelAnchor: "100 0",
                    labelClass: "marker-labels"
                };
            }
        }
    };

}]);

brianControllers.controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', 'clientFactory', 'reportFactory', 'searchResultsFactory',  'clientFactory_v3', function ($scope, $uibModalInstance, clientFactory, reportFactory, searchResultsFactory, clientFactory_v3) {
    ////console.log('ModalInstanceCtrl');

    $scope.purchase_purposes = [
        'Invesment', 'Redevelopment', 'Owner-User'
    ];

    $scope.investment_types = [
        'Fully rented', 'Rollover', 'Upside'
    ];

    $scope.building_classes = [
        'A', 'B', 'C', 'D'
    ];

 

    //2020-02-09
    $scope.elevator__fn = function (value) {
        $scope.submission.elevator = value;
    };


    //2020-02-01
    $scope.purchase_purpose__fn = function (value) {
        $scope.submission.purchase_purpose = value;
    };

    $scope.building_class_fn = function (value) {

        $scope.submission.building_class = value;
    };


    //2019-03-16
    //2019-03-30 tweaked

    $scope.chat_missing_fields_on = false;
    $scope.open_chat_now__fn = function (result) {
        $scope.submitted = true;
        if ($scope.form.space_form.$valid) {
            $scope.form_submission = true;
            $scope.submission.http_referrer = document.URL;
            $scope.submission.option = 'chat';
            $scope.submission.track = "ModalInstanceCtrl.clientFactory:2802";
            clientFactory.create($scope.submission).$promise.then(function (data) {
                $uibModalInstance.close(result);

                //2021-04-28
                $(".continually").show();
                $(".continually").click();

                // $('.drift-open-chat').click();
                // ////console.log('drift-open-chat >> click');
            });


        } else {
            $scope.chat_missing_fields_on = true;
        }


    };

   
    $scope.ajax_loader2 = false;
 
    var selectedItems = '';
    var clusters2 = document.getElementsByName('neighborhood_cluster');
    for (var i = 0, neighborhood; neighborhood = clusters2[i]; i++) {

        //2020-04-11 dirty hack, md-checkbox is not readable in modalinstance
        neighborhood.checked = neighborhood.getAttribute('aria-checked');
        if (neighborhood.checked == 'true') neighborhood.checked = true;
        else neighborhood.checked = false;
        neighborhood.value = neighborhood.getAttribute('value');


        if (neighborhood.checked) {
            selectedItems += neighborhood.value + ', ';
        }
    };

    var clusters2 = document.getElementsByName('neighborhood');
    for (var i = 0, neighborhood; neighborhood = clusters2[i]; i++) {

        //2020-04-11 dirty hack, md-checkbox is not readable in modalinstance
        neighborhood.checked = neighborhood.getAttribute('aria-checked');
        neighborhood.value = neighborhood.getAttribute('value');

        if (neighborhood.checked == 'true') neighborhood.checked = true;
        else neighborhood.checked = false;

        if (neighborhood.checked) {
            selectedItems += neighborhood.value + ', ';
        }
    };



    if (!($scope.submission.location)) {
        selectedItems = selectedItems.substring(0, selectedItems.length - 2);
        $scope.submission.location = selectedItems;

    }
    $scope.close = function (result) {
        $scope.submission.query_name = '';
        $uibModalInstance.close(result);
    };


    $scope.submission.ga_client_id = readCookie('_ga');

    $scope.submitted = false;
    $scope.phoneNumberPattern = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;
    $scope.form_submission = false;

    $scope.ajax_loader = false;
    $scope.submit_form = function () {
        $scope.submitted = true;
        $scope.ajax_loader = true;
        //console.log($scope.submission.page_id );

 
        if ($scope.form.space_form.$valid) {
            $scope.form_submission = true;
            $scope.submission.http_referrer = document.URL;

            //land  version3
            var intended_indexes = [1, 2, 9, 6, 131];
            var intended_index = intended_indexes.indexOf($scope.submission.intended_use_id);

            //land  version3
            if (($scope.submission.intended_use_id >= 133) || (intended_index >= 0)) {
                
                $scope.submission.track = "ModalInstanceCtrl.clientFactory_v3:2910";


                //20251011
                grecaptcha.execute('6LfagvEUAAAAANco96iY2EGGcERXrCKL1Cb59Gw6', {
                            action: 'landingMapsCtrl'
                    }).then(function (token) {
                        $scope.submission.token = token;
                        clientFactory_v3.create($scope.submission).$promise.then(function (data) {
                        $scope.ajax_loader = false;

                        if (intended_index >= 0) {
                            window.location = 'https://www.optimalspaces.com/space-search2/' + data.str + '/';
                        } else {
                            window.location = 'https://www.optimalspaces.com/building-search/' + data.str + '/';
                        }
                    });
                });


            } else {
                $scope.submission.track = "ModalInstanceCtrl.clientFactory:2924";
                clientFactory.create($scope.submission).$promise.then(function (data) {
                    $scope.ajax_loader = false;
                    if (($scope.submission.intended_use_id >= 133) && ($scope.submission.intended_use_id <= 142)) {
                        window.location = 'https://www.optimalspaces.com/building-search/' + data.str + '/';
                    } else {
                        window.location = 'https://www.optimalspaces.com/space-search/' + data.str + '/';
                    }
                });
            }
        } else {
            $scope.ajax_loader = false;
        }
    };

    $scope.number_of_desks = function (value) {
        $scope.submission.desks = value;
    };

    $scope.important_for_you = function (value) {
        $scope.submission.important_for_you = value;
    };

    //2018-03-24 added
    $scope.specific_req_on = false;
    $scope.specific_req_fn = function () {
        $scope.specific_req_on = $scope.specific_req_on === false ? true : false;
    };

    $scope.schedule_call = function () {

        //window.location= 'https://www.optimalspaces.com/schedule-a-call/';

        $scope.ajax_loader = true;
        $scope.submission.option = 'schedule_call';
        if ($scope.submission.intended_use_id == undefined) {
            $scope.submission.intended_use_id = 1;
        }
        if ($scope.submission.email) {
            $scope.submission.track = "ModalInstanceCtrl.clientFactory_v3:2968";
            clientFactory_v3.create($scope.submission).$promise.then(function (data) {
                $scope.ajax_loader = false;
                window.location = 'https://www.optimalspaces.com/schedule-a-call/';
            });
        } else {
            window.location = 'https://www.optimalspaces.com/schedule-a-call/';
        }



    };


    $scope.contact_us_submit = function () {

        if ($scope.submission.intended_use_id == undefined) {
            $scope.submission.intended_use_id = 1;
        }

        $scope.submission.option = 'contact_us';
        //20200416
        $scope.submit_form();

    };

    //PDF Download
    $scope.download_report_submit = function () {
        ////console.log('ModalInstanceCtrl.download_report_submit');
        $scope.submitted = true;
        $scope.ajax_loader = true;
        $scope.done = false;
        $scope.form_submission = false;
        if ($scope.form.download_form.$valid) {
            $scope.form_submission = true;

            $scope.submission.http_referrer = document.URL;

            $scope.broker = false;
            reportFactory.create($scope.submission).$promise.then(function (data) {
                $scope.ajax_loader = false;
                $scope.done = true;
                $scope.broker = data.broker;
                //if (!(data.broker))
                //window.location= 'https://www.optimalspaces.com/pdf/'+data.quick_code;

            });
        } else {
            $scope.ajax_loader = false;
        }

    };

}]);
brianControllers.controller("newsletterCtrl", ["$scope", "$timeout", "clientFactory", "visitorFactory", "modalFactory", "$uibModalStack", "reportFactory", "unico", function ($scope, $timeout, clientFactory, visitorFactory, modalFactory, $uibModalStack, reportFactory, unico) {

    //$scope.myInterval = 2000;
    // var currIndex = 0;

    $scope.clicks = {
        'buildings': false,
        'developments': false,
        'downtown_charts': false,
        'industrial_charts': false,
        'market_data': false,
        'midtown_charts': false,
        'midtown_south_charts': false,
        'office_charts': false,
        'office_leases': false,
        'overview': false,
        'retail_charts': false,
        'retail_leases': false
    };
    $scope.showThis = function (argument) {

        angular.forEach($scope.clicks, function (value, key) {
            $scope.clicks[key] = false;
            if (key == argument) $scope.clicks[key] = true;
        });

    };
    $scope.hideThis = function () {
        angular.forEach($scope.clicks, function (value, key) {
            $scope.clicks[key] = false;

        });
        $scope.clicks['show_event'] = true;
    };

    //2019-03-16
    $scope.find_my_space_top = function (page_id) {
        unico.find_my_space_top(page_id);
    };

    //2017-05-19 added
    $scope.find_my_space = function (page_id) {
        unico.find_my_space(page_id);
    };


    //newsletterCtrl
    $scope.contact_us = function (category) {
        unico.contact_us(category);
    };

    var timer = $timeout(function () {
        //unico.download_report();
    }, 3000);

    $scope.download_report = function (pdf_issue) {
        $timeout.cancel(timer);
        //if (pdf_issue) {
        //     $scope.submission.pdf_issue = pdf_issue;
        //}
        unico.download_report(pdf_issue);
    };

}]);

function formatDate(date) {
    var monthNames = [
        "01", "02", "03",
        "04", "05", "06", "07",
        "08", "09", "10",
        "11", "12"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return monthNames[monthIndex] + '/' + day + '/' + year;
}

brianControllers.controller("landingMapsCtrl", ["$scope", "$rootScope", "clientFactory", "$timeout", "marcadorFactory", "$http", '$location', '$anchorScroll', '$filter', 'gMarkerFactory', 'modalFactory', '$uibModalStack', 'unico', 'leafletData', 'clientFactory_v3', function ($scope, $rootScope, clientFactory, $timeout, marcadorFactory, $http, $location, $anchorScroll, $filter, gMarkerFactory, modalFactory, $uibModalStack, unico,  leafletData, clientFactory_v3) {

    $(document).ready(function () {
        "use strict";
        $('#activate_map').click(function (e) {
            $(".main_picture_container").removeClass("pevnts");
            $("#idmap").addClass("borders");
            
        });

    });

    //20200201
    $scope.show_map = true;

    //20200425
    $scope.submission.category = 'Office';
    $scope.submission_category__fn = function (category) {
        unico.contact_us_building_sales_v2(category);
    };

    //landingMapsCtrl
    $scope.contact_us_building_sales_v2_1 = function (category, location_for_sale, size, budget) {
        $scope.submission.needs = 'Re: ' + location_for_sale;
        $scope.submission.size = size;
        $scope.submission.budget = budget;
        //$scope.submission_category__fn('hospitality')

        unico.contact_us_building_sales_v2(category);
        //$scope.contact_us_building_sales_v2(page_id, type_for_sale_use_int);
    };

    //2019-12-14
    $scope.open_form = false;
    //$scope.hide_search_bar                         = false;
    $scope.$root.gmarker_click_fn = function (address) {

        //$scope.hide_search_bar   = true;
        $scope.open_form = true;
        $scope.cursor_on_form = true;
        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });
        $scope.submission.needs = 're coworking spaces at ' + address;

        unico.contact_us__fn(140);
    };


    //2019-12-12
    $scope.owl_carousel_click = function (index) {

        $scope.contact_us__fn(6);
        var owl = $('.owl-carousel');
        owl.trigger('to.owl.carousel', index)
    };

    //2019-12-12
    $scope.contact_us__fn = function (page_id) {


        $rootScope.submission.location = $scope.manhattan_cluster;
        $rootScope.submission.move_in_datex = formatDate($scope.move_in_date);
        $rootScope.submission.desks = $scope.number_of_desks_str;
        unico.contact_us__fn(page_id);
    };


    $scope.number_of_desks = 1;
    $scope.number_of_desks_str = "1 person";



    $scope.number_of_desks__fn = function (sum_rest) {
        if (sum_rest) {
            $scope.number_of_desks += 5;
        } else {
            $scope.number_of_desks -= 5;
        }
        if ($scope.number_of_desks > 1) {
            $scope.number_of_desks_str = $scope.number_of_desks + " people";
        } else {
            $scope.number_of_desks = 1;
            $scope.number_of_desks_str = "1 person";
        }

    };


    $scope.ajax_loader = false;
    $scope.submit_form_more = function (key) {

        $scope.submitted = true;
        $scope.ajax_loader = true;
        $scope.form_submission = false;
 
        if ($scope.space_form2.$valid) {
            $scope.submission.http_referrer = document.URL;
            $scope.submission.key = key;
            $scope.submission.option = 'update_client';
            $scope.form_submission = true;

            clientFactory.update($scope.submission).$promise.then(function (data) {
                $scope.ajax_loader = false;
                window.location = 'https://www.optimalspaces.com/thank-you/';
            });
        } else {
            $scope.ajax_loader = false;
        }
    };

    $scope.submit_form_more2 = function (key, schedule_call) {

        $scope.submitted = true;
        $scope.ajax_loader = true;
        $scope.form_submission = false;

 
        if ($scope.space_form2.$valid) {
            $scope.submission.http_referrer = document.URL;
            $scope.submission.key = key;
            $scope.submission.option = 'update_client';
            $scope.form_submission = true;

            clientFactory.update($scope.submission).$promise.then(function (data) {
                $scope.ajax_loader = false;
                //20260208 sps requested this by default not thank-you
                window.location = 'https://www.optimalspaces.com/schedule-a-call/';
            });
        } else {
            $scope.ajax_loader = false;
        }
    };


    $scope.popup1 = {
        opened: false
    };
    $scope.open1 = function () {
        $scope.popup1.opened = true;
    };
    $scope.today = function () {
        $scope.move_in_date = new Date();
    };
    $scope.today();

    $scope.clear = function () {
        $scope.move_in_date = null;
    };
    // Disable weekend selection
    function disabled(data) {
        var date = data.date,
            mode = data.mode;
        return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[2];
    $scope.altInputFormats = ['M!/d!/yyyy'];

    $scope.dateOptions = {

        dateDisabled: disabled,
        formatYear: 'yy',
        maxDate: new Date(2099, 5, 22),
        minDate: new Date(),
        startingDay: 1,
        showWeeks: false
    };


    //2019-12-10
    $scope.clusters = [{
        name: "Midtown",
        id: 1
    }, {
        name: "Midtown South",
        id: 2
    }, {
        name: "Downtown",
        id: 3
    }];



    //2019-11-10
    $scope.open_form = false;
    $scope.$root.gmarker_window2_clicked4 = function (address) {

        $scope.open_form = true;
        $scope.cursor_on_form = true;

        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });
        $scope.submission.needs = 're coworking spaces at ' + address;
        //$scope.find_my_space(1);
    };


    //2019-10-15
    // $scope.contador =
    $(document).ready(function () {
        "use strict";

        // $('#property-slider2')



        if ($('#property-slider1').length > 0) {
            $('#property-slider1').owlCarousel({
                items: 10,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });
        }
        if ($('#property-slider2').length > 0) {

            $('#property-slider2').owlCarousel({
                items: 14,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });

        }

        if ($('#property-slider3').length > 0) {
            $('#property-slider3').owlCarousel({
                items: 14,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });

        };
        //2019-10-23
        if ($('#property-slider4').length > 0) {
            $('#property-slider4').owlCarousel({
                items: 10,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });
        }
        if ($('#property-slider5').length > 0) {

            $('#property-slider5').owlCarousel({
                items: 14,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });

        }

        if ($('#property-slider6').length > 0) {
            $('#property-slider6').owlCarousel({
                items: 14,
                singleItem: true,
                slideSpeed: 250,
                autoPlay: 3500,
                stopOnHover: true,
                navigation: true,
                navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                pagination: true
            });

        };
    });


    //2020-01-22
    $scope.open_form = false;
    $scope.$root.gmarker_window2_clicked7 = function (listing_id) {
        $scope.open_form = true;
        var marker = $filter("filter")($scope.markers, {
            'listing_id': parseInt(listing_id)
        }, true)
        $scope.cursor_on_form = true;

        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });

        $scope.submission.needs = 're listing_id #' + listing_id + ', we are looking to purchase ' + marker[0].size + ' ';
        //$scope.find_my_space(1);




    };


    // 2019-11-10 commented below we don't need it I guess
    //2019-05-11
    $scope.$root.gmarker_window2_clicked5 = function (listing_id) {
        $scope.open_form = true;

        var marker = $filter("filter")($scope.markers, {
            'listing_id': parseInt(listing_id)
        }, true)

        $scope.cursor_on_form = true;

        leafletData.getMap('map_basic').then(function (map) {
            map.closePopup();
        });

        $scope.submission.needs = 're listing_id #' + listing_id + ', we are looking for ' + marker[0].size + ' ';
        //$scope.find_my_space(1);




    };



    $scope.step = 0;
    $scope.next_screen = function (step, value) {

        if (step == 1) {
            $scope.submission.intended_use_str = value;
        }
        $scope.step = step;
        if (step == 3) {
            $scope.submission.timeline = value;
            $scope.contact_us(6);
        }

    };

    /* 20170718 */
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    $scope.submission.ga_client_id = readCookie('_ga');

    $scope.submitted = false;
    $scope.phoneNumberPattern = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;
    $scope.form_submission = false;

    $scope.ajax_loader = false;
    $scope.submit_form = function () {
        $scope.submitted = true;
        $scope.ajax_loader = true;


            if ($scope.form.space_form.$valid) {
                $scope.form_submission = true;
                $scope.submission.http_referrer = document.URL;

                //land  version3
                var intended_indexes = [1, 2, 9, 6, 131];
                var intended_index = intended_indexes.indexOf($scope.submission.intended_use_id);

                if (($scope.submission.intended_use_id >= 133) || (intended_index >= 0)) {
                    $scope.submission.track = "landingMapsCtrl.clientFactory_v3";

                    //20251009
                    grecaptcha.execute('6LfagvEUAAAAANco96iY2EGGcERXrCKL1Cb59Gw6', {
                                action: 'landingMapsCtrl'
                            }).then(function (token) {

                            $scope.submission.token = token;
                    
                            clientFactory_v3.create($scope.submission).$promise.then(function (data) {
                                $scope.ajax_loader = false;

                                if (intended_index >= 0) {
                                    window.location = 'https://www.optimalspaces.com/space-search2/' + data.str + '/';
                                } else {
                                    window.location = 'https://www.optimalspaces.com/building-search/' + data.str + '/';
                                }


                            });
                    });
                } else {
                    
                    $scope.submission.track = "landingMapsCtrl.clientFactory";
                    clientFactory.create($scope.submission).$promise.then(function (data) {
                        $scope.ajax_loader = false;
                        //window.location= 'https://www.optimalspaces.com/thank-you/';
                        window.location = 'https://www.optimalspaces.com/space-search/' + data.str + '/';
                    });
                }
            } else {
                $scope.ajax_loader = false;
            }

    //  });

    };

    //20240316 > neighborhood landing page
    $scope.schedule_call = function () {

        $scope.submitted = true;
        $scope.ajax_loader = true;
        $scope.submission.option = 'schedule_call';

        

        if ($scope.form.space_form.$valid) {
            $scope.form_submission = true;
            $scope.submission.http_referrer = document.URL;

            clientFactory_v3.create($scope.submission).$promise.then(function () {
                $scope.ajax_loader = false;
                window.location = 'https://www.optimalspaces.com/schedule-a-call/';
            });

        } else {
            $scope.ajax_loader = false;
        }
    };

    //2017-05-19 added
    $scope.find_my_space = function (page_id) {
        unico.find_my_space(page_id);
    };



    $scope.contact_us = function (category) {
        unico.contact_us(category);
    };


    // $scope.contact_us = function (category) {
    //     $rootScope.h1_form = category.charAt(0).toUpperCase() + category.slice(1) + " Space For Rent";
    //     unico.contact_us(category);
    // };
   
    $scope.contact_us3 = function (category) {
        // $rootScope.h1_form = category.charAt(0).toUpperCase() + category.slice(1) + " Space For Rent";
        unico.contact_us__fn3(category);
    };

    //2017-05-31 added
    $scope.show_space_info = function (space_id) {
        unico.show_space_info(space_id);
    };

    $scope.maps_filter = false;
    $scope.toggleFilter = function () {
        $scope.maps_filter = $scope.maps_filter === false ? true : false;
    };

    $scope.submitted = false;

    $scope.phoneNumberPattern = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;
    $scope.form_submission = false;
    $scope.cursor_on_form = false;

    $scope.intended_uses = [{
            id: 1,
            name: "Office"
        },
        {
            id: 2,
            name: "Retail"
        },
        {
            id: 3,
            name: "Industrial"
        },
        {
            id: 6,
            name: "Educational"
        },
        {
            id: 7,
            name: "Loft"
        },
        {
            id: 8,
            name: "Store"
        },
        {
            id: 9,
            name: "Medical"
        },
        {
            id: 11,
            name: "Residential"
        },
        {
            id: 4,
            name: "Other"
        },
    ];


    // $timeout(function () {

    //         $scope.map = {
    //                     showMap: true,
    //             center: {
    //                 latitude:   40.7549003,
    //                 longitude: -73.9655241
    //             },
    //            refresh: function () {
    //               //20170717 commented (below code resizes the "div", sps asked to not use the entire screen)
    //               /*
    //               $scope.map.control.refresh();
    //               $scope.map.showMap = false;
    //               $timeout(function () {
    //                 $scope.map.showMap = true;
    //                  google.maps.event.trigger($scope.map, 'resize');
    //               }, 100); */
    //             },
    //             zoom: 15,
    //             options: {
    //                 zoomControl: true,
    //                 minZoom: 13,
    //                 maxZoom: 20,
    //                 mapTypeControl: false,
    //                 streetViewControl: true,
    //                 draggable: true,
    //                 panControl: false,
    //                 optimized: true,
    //                 mapTypeId: 'roadmap',
    //                 styles: [
    //                          {featureType: "poi",         stylers: [          {            visibility: "on"          }        ]      },
    //                          {featureType: "poi.park",    stylers: [          {            visibility: "simplified"          }        ]      },
    //                          {featureType: "road",        stylers: [          {            visibility: "simplified"          }        ]      },
    //                          {featureType: "transit",     stylers: [          {            visibility: "on"          }        ]      },
    //                          {featureType: "landscape",   stylers: [          {            visibility: "simplified"          }        ]      },
    //                          {featureType: "road.highway",      stylers: [          {            visibility: "off"          }        ]      },
    //                          {featureType: "road.local",        stylers: [          {            visibility: "on"          }        ]      },
    //                          {featureType: "road.highway",        "elementType": "geometry",        stylers: [          {            visibility: "on"          }        ]      },
    //                          {featureType: "road.arterial",        stylers: [          {            visibility: "on"          }        ]      },
    //                          {featureType: "water",        stylers: [          {            "color": "#B3D1FF"          }        ]      },
    //                          {featureType: "road.highway",        stylers: [          {            "weight": 0.36          },          {            "saturation": -25          },          {            "lightness": 31          }        ]      },
    //                          {featureType: "road"      },
    //                          //{featureType: "landscape",        stylers: [          {            "hue": "#0066ff"          },          {            "saturation": 74          },          {"lightness": 100}]}
    //                 ]
    //            },
    //            markersEvents: {
    //               click: function(marker, eventName, model) {
    //                  $scope.this_marker      = model;
    //                  $scope.map.window.model = model;
    //                  $scope.map.window.show  = true;

    //                  if (!(model.executive)) {
    //                     $scope.submission.size   = 'Size:   ' +model.size;
    //                  }

    //                  //$scope.submission.budget    = 'Budget: ' +model.rent_amount;
    //                  $scope.submission.intended_use_str = 'Intended Use: '+ $scope.q.split(":")[1];

    //                  $scope.submission.k        = model.panda_key;
    //                  //$scope.spaceInfo           = model; //only used when modal is open

    //                  $scope.cursor_on_form = true;

    //                  $scope.submission.coworking_address = model.coworking_address;
    //                  $scope.submission.coworking_id = model.coworking_id;

    //                 //landingMapsCtrl
    //                 //  // 20170717
    //                 //  if (!($scope.markerClicked)) {
    //                 //      $('#trick_cols').addClass('col-xs-12 col-sm-6 col-md-6 col-lg-6');
    //                 //      $('#trick_cols').removeClass('col-xs-12 col-sm-12 col-md-12 col-lg-12');

    //                 //        $scope.markerClicked = true;
    //                 //        //$scope.columnWidth = "col-sm-12 col-md-12 col-lg-12";
    //                 //        //$scope.map.refresh();
    //                 //  }

    //              }
    //            },
    //         window: {
    //           marker:     {},
    //           show:       false,
    //           closeClick: function() {
    //             this.show = false;
    //           },
    //           options: {

    //            disableAutoPan: true,
    //            }
    //         },
    //         control: {}

    //         };
    // }, 200);

    var categories = [];
    $scope.checked_box = function (category_id) {

        for (var i = 0; i < categories.length; i++) {
            if (categories[i] === category_id) {
                return true;
            }
        }

        return false;
    }

    var categories = [];

    $scope.crud_category = function (category_id) {
        var category_exists = $filter("filter")(categories, category_id);
        if (category_exists.length > 0) {
            var pos = categories.indexOf(category_exists[0]);
            categories.pop(pos);
            var markers_to_remove = $filter("filter")($scope.markers, {
                'category_id': category_id
            })
            angular.forEach(markers_to_remove, function (m) {
                $scope.markers.splice($scope.markers.indexOf(m), 1);
            });
        } else {
            categories.push(category_id);
            $scope.q2 = $scope.q + ':' + category_id;
            gMarkerFactory.query({
                'q': $scope.q2
            }).$promise.then(function (data) {
                $scope.markers = $scope.markers.concat($scope.markers, data);
            });
        }

    }
    var tilesDict = {
        // openstreetmap: {
        //     url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        //     options: {
        //         attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        //     }
        // },
        // opencyclemap: {
        //     url: 'https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=153aaa3e51d4422390e5a03f4b77985d',

        //     //url: "http://{s}.tile.opencyclemap.org/cycle/{z}/{x}/{y}.png",
        //     options: {
        //         attribution: 'All maps &copy; <a href="http://www.opencyclemap.org">OpenCycleMap</a>, map data &copy; <a href="http://www.openstreetmap.org">OpenStreetMap</a> (<a href="http://www.openstreetmap.org/copyright">ODbL</a>'
        //     }
        // },
        //2019-04-28
        mapbox1: {
            //url: 'https://api.mapbox.com/styles/v1/{styleID}/tiles/{z}/{x}/{y}?access_token={apikey}',
            url: 'https://api.mapbox.com/styles/v1/{styleID}/tiles/256/{z}/{x}/{y}?access_token={apikey}',

            //url: 'https://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
            options: {
                apikey: 'pk.eyJ1Ijoib3B0aW1hbHNwYWNlcyIsImEiOiJjanJvNXhqeGkwNmJlNDlwM2xhdmZkcjZ3In0.uGIEwuw8h0jkPB1g2gtmXg',
                styleID: 'optimalspaces/cjtmdur6oca5w1fpi98zk7kzg',
            }
        },
    };

    // $scope.center = {
    //     lat:  40.744916,
    //     lng:  -73.991075,
    //     zoom: 13,
    // },


    //2019-02-02 landing maps ctrl
    angular.extend(
        $scope,
        {
        center: {
            lat: 40.744916,
            lng: -73.991075,
            zoom: 13,
        },
        tiles: tilesDict.mapbox1,

        defaults: {
            scrollWheelZoom: false,
            dragging: true, //20240304 map
            doubleClickZoom: true,
            zoomControl: true,
        },

    });



    //2019-09-14
    //comment

    $timeout(function () {

        //20230808 the slug is the 4th '/'-separated chunk of the href:
        // 'https://www.optimalspaces.com/rent-soho-office/' -> 'rent-soho-office'
        var lastSegment = window.location.href.split('/')[3];

        //2019-10-09 improve speed!!!!!!!!
        var new_query = {
            'q': $scope.q,
            'v': 2
        };

        // Landing-page slug -> [query key, landing page id].
        // Was a 172-case switch; 4 slugs appeared twice with identical values, so the
        // 168 entries here are the whole of it. Sorted by key, then slug.
        var SLUG_QUERY = {
            // Manhattan / NYC office (whole-market + class pages)
            'rent-manhattan-office':        ['man', 174],
            'rent-new-york-office':         ['man', 174],
            'rent-office-class-A-new-york': ['man', 953],
            'rent-office-class-B-new-york': ['man', 954],
            'rent-office-class-C-new-york': ['man', 955],

            // Manhattan / NYC retail
            'rent-manhattan-retail':          ['manr', 175],
            'rent-new-york-retail':           ['manr', 175],
            'rent-rockefeller-center-retail': ['manr', 49],

            // Manhattan / NYC medical
            'affittare-new-york-medical':    ['manm', 176],
            'alquiler-medico-de-nueva-york': ['manm', 176],
            'louer-new-york-medical':        ['manm', 176],
            'miete-new-york-medizin':        ['manm', 176],
            'rent-manhattan-medical':        ['manm', 176],
            'rent-new-york-medical':         ['manm', 176],

            // Manhattan / NYC school
            'rent-manhattan-educational': ['mane', 177],
            'rent-new-york-school':       ['mane', 177],

            // medical, by neighborhood
            'flatiron-district-medical-for-rent':  ['manm_pk', 181],
            'rent-bowery-medical':                 ['manm_pk', 197],
            'rent-chelsea-medical':                ['manm_pk', 179],
            'rent-columbus-circle-medical':        ['manm_pk', 178],
            'rent-financial-district-medical':     ['manm_pk', 180],
            'rent-garment-district-medical':       ['manm_pk', 198],
            'rent-gramercy-park-medical':          ['manm_pk', 196],
            'rent-grand-central-medical':          ['manm_pk', 182],
            'rent-greenwich-village-medical':      ['manm_pk', 183],
            'rent-hudson-yards-medical':           ['manm_pk', 199],
            'rent-lincoln-square-medical':         ['manm_pk', 200],
            'rent-lower-east-side-medical':        ['manm_pk', 184],
            'rent-madison-square-medical':         ['manm_pk', 201],
            'rent-meatpacking-district-medical':   ['manm_pk', 185],
            'rent-midtown-south-new-york-medical': ['manm_pk', 135],
            'rent-murray-hill-medical':            ['manm_pk', 186],
            'rent-noho-medical':                   ['manm_pk', 202],
            'rent-penn-plaza-medical':             ['manm_pk', 187],
            'rent-plaza-district-medical':         ['manm_pk', 188],
            'rent-rockefeller-center-medical':     ['manm_pk', 189],
            'rent-soho-medical':                   ['manm_pk', 190],
            'rent-times-square-medical':           ['manm_pk', 191],
            'rent-tribeca-medical':                ['manm_pk', 192],
            'rent-un-plaza-medical':               ['manm_pk', 193],
            'rent-union-square-medical':           ['manm_pk', 203],
            'rent-upper-east-side-medical':        ['manm_pk', 194],
            'rent-upper-west-side-medical':        ['manm_pk', 204],
            'rent-wall-street-medical':            ['manm_pk', 205],
            'rent-world-trade-center-medical':     ['manm_pk', 195],

            // school (a few slugs still say "educational"), by neighborhood
            'flatiron-school-for-rent':         ['eduk', 209],
            'rent-bowery-school':               ['eduk', 225],
            'rent-chelsea-school':              ['eduk', 207],
            'rent-columbus-circle-school':      ['eduk', 206],
            'rent-financial-district-school':   ['eduk', 208],
            'rent-garment-district-school':     ['eduk', 226],
            'rent-gramercy-park-school':        ['eduk', 224],
            'rent-grand-central-school':        ['eduk', 210],
            'rent-greenwich-village-school':    ['eduk', 211],
            'rent-hudson-yards-school':         ['eduk', 227],
            'rent-lincoln-square-school':       ['eduk', 228],
            'rent-lower-east-side-school':      ['eduk', 212],
            'rent-madison-square-school':       ['eduk', 229],
            'rent-meatpacking-district-school': ['eduk', 213],
            'rent-murray-hill-school':          ['eduk', 214],
            'rent-noho-school':                 ['eduk', 230],
            'rent-penn-plaza-educational':      ['eduk', 215],
            'rent-plaza-district-school':       ['eduk', 216],
            'rent-rockefeller-center-school':   ['eduk', 217],
            'rent-soho-school':                 ['eduk', 218],
            'rent-times-square-school':         ['eduk', 219],
            'rent-tribeca-school':              ['eduk', 220],
            'rent-un-plaza-school':             ['eduk', 221],   // 20260731 was 215 (= Penn Plaza, retired); URLconf routes this slug to landing page 221
            'rent-union-square-school':         ['eduk', 231],
            'rent-upper-east-side-school':      ['eduk', 222],
            'rent-upper-west-side-school':      ['eduk', 232],
            'rent-wall-street-school':          ['eduk', 233],
            'rent-world-trade-center-school':   ['eduk', 223],

            // office, by neighborhood
            'flatiron-district-office-for-rent':  ['ok', 8],
            'rent-14th-st-office':                ['ok', 53],
            'rent-34th-street-office':            ['ok', 54],
            'rent-bowery-office':                 ['ok', 58],
            'rent-broadway-office':               ['ok', 59],
            'rent-chelsea-office':                ['ok', 5],
            'rent-columbus-circle-office':        ['ok', 4],
            'rent-fifth-avenue-office':           ['ok', 60],
            'rent-financial-district-office':     ['ok', 7],
            'rent-garment-district-office':       ['ok', 61],
            'rent-gramercy-park-office':          ['ok', 33],
            'rent-grand-central-office':          ['ok', 10],
            'rent-greenwich-village-office':      ['ok', 11],
            'rent-harlem-office':                 ['ok', 62],
            'rent-hudson-square-office':          ['ok', 12],
            'rent-hudson-yards-office':           ['ok', 63],
            'rent-insurance-district-office':     ['ok', 13],
            'rent-lincoln-square-office':         ['ok', 64],
            'rent-lower-east-side-office':        ['ok', 149],
            'rent-madison-square-office':         ['ok', 65],
            'rent-meatpacking-district-office':   ['ok', 14],
            'rent-midtown-west-offices-for-rent': ['ok', 142],
            'rent-murray-hill-office':            ['ok', 15],
            'rent-noho-office':                   ['ok', 68],
            'rent-penn-plaza-office':             ['ok', 16],
            'rent-plaza-district-office':         ['ok', 17],
            'rent-rockefeller-center-office':     ['ok', 18],
            'rent-soho-office':                   ['ok', 19],
            'rent-times-square-office':           ['ok', 20],
            'rent-tribeca-office':                ['ok', 21],
            'rent-un-plaza-office':               ['ok', 22],
            'rent-union-square-office':           ['ok', 69],
            'rent-upper-east-side-office':        ['ok', 23],
            'rent-upper-west-side-office':        ['ok', 71],
            'rent-wall-street-office':            ['ok', 72],
            'rent-world-trade-center-office':     ['ok', 24],

            // retail, by neighborhood
            'flatiron-district-retail-for-rent': ['rk', 52],
            'rent-bowery-retail':                ['rk', 81],
            'rent-chelsea-retail':               ['rk', 29],
            'rent-columbus-circle-retail':       ['rk', 28],
            'rent-fifth-avenue-retail':          ['rk', 51],
            'rent-financial-district-retail':    ['rk', 31],
            'rent-garment-district-retail':      ['rk', 78],
            'rent-gramercy-park-retail':         ['rk', 74],
            'rent-grand-central-retail':         ['rk', 34],
            'rent-greenwich-village-retail':     ['rk', 35],
            'rent-hudson-square-retail':         ['rk', 36],
            'rent-hudson-yards-retail':          ['rk', 75],
            'rent-insurance-district-retail':    ['rk', 37],
            'rent-lincoln-square-retail':        ['rk', 82],
            'rent-madison-avenue-retail':        ['rk', 50],
            'rent-meatpacking-district-retail':  ['rk', 38],
            'rent-murray-hill-retail':           ['rk', 39],
            'rent-noho-retail':                  ['rk', 84],
            'rent-penn-plaza-retail':            ['rk', 40],
            'rent-plaza-district-retail':        ['rk', 41],
            'rent-soho-retail':                  ['rk', 43],
            'rent-times-square-retail':          ['rk', 44],
            'rent-tribeca-retail':               ['rk', 45],
            'rent-un-plaza-retail':              ['rk', 46],
            'rent-union-square-retail':          ['rk', 76],
            'rent-upper-east-side-retail':       ['rk', 47],
            'rent-upper-west-side-retail':       ['rk', 73],
            'rent-world-trade-center-retail':    ['rk', 48],

            // office, by cluster (midtown / midtown south / downtown / uptown)
            'rent-42nd-street-office':            ['clk', 57],
            'rent-downtown-new-york-office':      ['clk', 3],
            'rent-midtown-east-office':           ['clk', 67],
            'rent-midtown-new-york-office':       ['clk', 1],
            'rent-midtown-south-new-york-office': ['clk', 2],
            'rent-uptown-new-york-office':        ['clk', 144],

            // retail, by cluster
            'midtown-retail-space-for-rent':      ['clrk', 25],
            'rent-downtown-new-york-retail':      ['clrk', 27],
            'rent-midtown-east-retail':           ['clrk', 79],
            'rent-midtown-south-new-york-retail': ['clrk', 26],
            'uptown-retail-space-for-rent':       ['clrk', 145],

            // office, by industry
            'rent-accounting-new-york-office':             ['ik', 146],
            'rent-financial-firm-new-york-office':         ['ik', 148],
            'rent-gym-business-new-york-office':           ['ik', 161],
            'rent-hedge-fund-new-york-office':             ['ik', 173],
            'rent-hotel-group-new-york-office':            ['ik', 162],
            'rent-jewelry-business-new-york-office':       ['ik', 163],
            'rent-law-firm-new-york-office':               ['ik', 167],
            'rent-media-company-new-york-office':          ['ik', 151],
            'rent-medical-firm-new-york-office':           ['ik', 147],
            'rent-non-for-profit-new-york-office':         ['ik', 159],
            'rent-showroom-new-york-office':               ['ik', 169],
            'rent-technology-company-new-york-office':     ['ik', 170],
            'rent-trade-business-company-new-york-office': ['ik', 171],
            'rent-wholesale-business-new-york-office':     ['ik', 172],

            // for sale
            'manhattan-buildings-for-sale':             ['forSale', 237],
            'manhattan-condos-for-sale':                ['forSale', 234],
            'manhattan-multifamily-buildings-for-sale': ['forSale', 235],
            'manhattan-offices-for-sale':               ['forSale', 237],
            'manhattan-retail-for-sale':                ['forSale', 236],

            // executive suites
            'rent-executive-office-suites': ['exec', 140],
        };

        //2023-04-30 trick to get all translations from ROOT_ID: a translated page's
        // slug is not in SLUG_QUERY, so when the id is known we force the English slug
        // and let the table answer. (Every id below resolves to itself.)
        var SLUG_FOR_ROOT_ID = {
            146: 'rent-accounting-new-york-office',      //2022-06-10
            148: 'rent-financial-firm-new-york-office',
            151: 'rent-media-company-new-york-office',
            159: 'rent-non-for-profit-new-york-office',
            161: 'rent-gym-business-new-york-office',
            162: 'rent-hotel-group-new-york-office',
            163: 'rent-jewelry-business-new-york-office',
            167: 'rent-law-firm-new-york-office',
            170: 'rent-technology-company-new-york-office',
            171: 'rent-trade-business-company-new-york-office',
            172: 'rent-wholesale-business-new-york-office',
            173: 'rent-hedge-fund-new-york-office',
            174: 'rent-new-york-office',
            175: 'rent-new-york-retail'
        };

        // own-property lookups only: a slug like 'toString' or '__proto__' would
        // otherwise hit Object.prototype and pass a function off as a match.
        var has = function (obj, key) {
            return Object.prototype.hasOwnProperty.call(obj, key);
        };

        if (has(SLUG_FOR_ROOT_ID, $scope.q)) {
            lastSegment = SLUG_FOR_ROOT_ID[$scope.q];
        }
        // Coworking and zip-level pages carry their id in $scope.q instead of the slug.
        else if ($scope.q >= 1087) {
            new_query = { 'coworking': $scope.q };
        }
        else if ($scope.q >= 957) {
            new_query = { 'zlk': $scope.q };
        }

        //20260801 Send the v2 payload instead of the per-key legacy one. v2 is the
        //generic server path: it takes {q: <landing page id>, v: 2}, derives the search
        //table from Landing_Page.type_of_space and resolves root_id itself, so it does
        //not need the query KEY at all. Translated pages already rely on it (their slugs
        //are absent from SLUG_QUERY, so they fall through to the v2 initializer above).
        //
        //The legacy per-key branches all fell through to jsonn_markers__fn's DEFAULT
        //o_search, which is why every medical and retail-cluster page was serving an
        //EMPTY map: their pins are written under m_search / r_search and nothing ever
        //read them. Verified over all 168 slugs against prod (legacy vs v2, comparing
        //x_search + marker count + marker signature):
        //  manm_pk 29 pages  o_search n=0 -> m_search n=5..31   FIXED
        //  manm     6 pages  o_search n=0 -> m_search n=20      FIXED
        //  clrk     5 pages  o_search n=0 -> r_search n=10..16  FIXED
        //  eduk/mane 30 pgs  o_search n=0 -> e_search n=0       right namespace, pins
        //                                                       not built yet
        //  ok/rk/ik/clk/man/manr 92 pages                       byte-identical
        var V2_UNSAFE = { 'forSale': 1, 'exec': 1 };

        var hit = has(SLUG_QUERY, lastSegment) ? SLUG_QUERY[lastSegment] : null;
        if (hit) {
            new_query = {};
            if (has(V2_UNSAFE, hit[0])) {
                //These two REGRESS under v2 and must keep the legacy key. Their pages
                //carry a root_id, which the v2 branch follows before reading pins, so
                //all 5 forSale pages collapse onto the same 19 generic markers
                //(condos alone lose its own 6), and exec drops 43 -> 19 because the
                //legacy branch calls jsonn_coworking_spaces__fn, not jsonn_markers__fn.
                new_query[hit[0]] = hit[1];   // built fresh: never hand the table out
            } else {
                new_query['q'] = hit[1];
                new_query['v'] = 2;
            }
        }

        marcadorFactory.query(new_query).$promise.then(function (data) {

            // The old 17-way || test here listed every key any path above can set
            // (v / coworking / zlk / the 13 table keys) and every value is truthy, so
            // it was always true. The angular.extend() it guarded is the only one that
            // ever ran; the second copy, and its landing_page_id == 140 case, were dead.
            var data__coordinates = [];
            if (data.coordinates && data.coordinates.length) {
                data__coordinates = JSON.parse(data.coordinates);
            }

            angular.extend($scope, {
                markers: data.markers,
                orangeLeafIcon: {
                    iconUrl: 'img/leaf-orange.png',
                    shadowUrl: 'img/leaf-shadow.png',
                    iconSize: [38, 95],
                    shadowSize: [50, 64],
                    iconAnchor: [22, 94],
                    shadowAnchor: [4, 62],
                    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
                },
                icon: {
                    url: 'http://cdn.leafletjs.com/leaflet-0.6.4/images/marker-icon.png',
                    retinaUrl: 'http://cdn.leafletjs.com/leaflet-0.6.4/images/marker-icon@2x.png',
                    size: [25, 41],
                    anchor: [12, 40],
                    popup: [0, -40],
                    shadow: {
                        url: 'http://cdn.leafletjs.com/leaflet-0.6.4/images/marker-shadow.png',
                        retinaUrl: 'http://cdn.leafletjs.com/leaflet-0.6.4/images/marker-shadow.png',
                        size: [41, 41],
                        anchor: [12, 40]
                    }
                },
                defaults: {
                    scrollWheelZoom: false,
                    dragging: true,
                    doubleClickZoom: true,
                    zoomControl: true
                },
                //2019-05-27 added
                geojson: {
                    data: {
                        "type": "FeatureCollection",
                        "features": [{
                            "type": "Feature",
                            "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                    data__coordinates
                                ]
                            }
                        }]
                    },
                    style: {
                        fillColor: "#1a837a",
                        weight: 2,
                        opacity: 1,
                        color: '#1a837a',
                        dashArray: '3',
                        fillOpacity: 0.4
                    }
                },
                tiles: tilesDict.mapbox1
            });

            leafletData.getMap('map_basic').then(function (map) {
                //20250124
                $scope.map_loaded = false;
                map.whenReady(function () {
                    $scope.map_loaded = true;
                });
            });
        });
    });


}]);



//20241005 this controller below was moved to /home/optimals/djcode/perdido/static/scripts/src/pulsar_building_landing_page/buildingsPageCtrl.js
// brianControllers.controller("buildingsPageCtrl", ["$scope", "clientFactory_v3", "unico", "modalFactory", "clientFactory", "$timeout", "marcadorFactory", "$http", '$location', '$anchorScroll', '$uibModalStack', 'leafletData', function ($scope, clientFactory_v3, unico, modalFactory, clientFactory, $timeout, marcadorFactory, $http, $location, $anchorScroll, $uibModalStack, leafletData) {
//  /* 20240318
//     make edits here >>> /home/optimals/djcode/perdido/static/scripts/src/pulsar_building_landing_page/brian.controllers.js  */
//  /* grunt here >>     */


// }]);




brianControllers.controller("testimonialCtrl", ["$scope", "modalFactory", function ($scope, modalFactory) {

    $scope.open_testimonial = function (testimonial_id) {
        $scope.testimonial_id = testimonial_id;
        modalFactory.openTestimonial($scope);
    };

}]);;var services = angular.module('brian.factories', ['ngResource']);

services.factory('modalFactory', ['$uibModal', '$filter', function ($uibModal, $filter) {
        var openVentana = function ($scope, template, ident) {
        var templateURL = '//www.optimalspaces.com/static/mpages/' + template + '.php';
        var modalAddEditDialogOptions = {
            animation: false,
            scope: $scope,
            backdrop: 'static',
            keyboard: true,
            windowClass: template + '_modal',
            resolve: {
                thank_you: function () {
                    return '123'; //$scope.thank_you
                }
            },
            templateUrl: templateURL,
            controller: 'ModalInstanceCtrl'
        };
         $uibModal.open(modalAddEditDialogOptions);
 

    };
    return {
        //2020-05-22
        contact_us2_form_b4: function ($scope) {
            return openVentana($scope, 'b4__contact_us_form_2');
        },
        contact_us2_form_b5: function ($scope) {
            return openVentana($scope, 'b2025__contact_us_form');
        },

        //2020-05-15
        contact_us_building_for_sale_form_v1__b4: function ($scope) {
            return openVentana($scope, 'b4__building_for_sale_form');
        },
        //2020-05-14
        contact_us_form_b4: function ($scope) {
            return openVentana($scope, 'b4__contact_us_form');
        },

        //2020-03-17
        contact_us_re_consulting: function ($scope) {
            return openVentana($scope, 'b4__contact_us_re_consulting');
            //return openVentana($scope, 'contact_us_re_consulting');
        },
        //2020-02-01
        contact_us_building_for_sale_form__v2: function ($scope) {
            return openVentana($scope, 'contact_Us_Buildings_For_Sale_Form');
        },
        contact_us_building_for_sale_form_v1: function ($scope) {
            return openVentana($scope, 'contactUsBuildingsForSaleForm');
        },
        show_space_info: function ($scope) {
            return openVentana($scope, 'spaceInfoForm');
        },

        find_my_space_form: function ($scope) {
            return openVentana($scope, 'b4__contact_us_form');
            //return openVentana($scope, 'contactUsForm');
            //return openVentana($scope, 'spaceForm');
        },

        //2019-06-02
        chat_us_form: function ($scope) {
            return openVentana($scope, 'chatUsForm');
        },
        contact_us_form: function ($scope) {
            return openVentana($scope, 'contactUsForm');
        },
        contact_us2_form: function ($scope) {
             return openVentana($scope, 'contact_Us_Form_2');
         },



        download_form: function ($scope) {
            return openVentana($scope, 'downloadForm');
        },
        search_results_table: function ($scope) {
            return openVentana($scope, 'search_results_table');
        },
    }
}]);
services.factory('spaceFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/space_numbers/', {}, {
        space_numbers: {
            method: 'PUT'
        }
    })
});
services.factory('marcadorFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/markers/', {}, {
        query: {
            method: 'PUT'
        },
    })
});
services.factory('gMarkerFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/gmarkers/', {}, {
        query: {
            method: 'PUT',
            isArray: true,
        },
    })
});
services.factory('clientFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/D6n82bCyli/', {}, {
        create: {
            method: 'PUT'
        },
        update: {
            method: 'PUT'
        }
    })
});

services.factory('clientFactory_v3', function ($resource) {
    return $resource('//www.optimalspaces.com/api/', {}, {
        create: {
            method: 'PUT'
        },
        update: {
            method: 'PUT'
        }
    })
});


services.factory('reportFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/V2IY6h8Xw688/', {}, {
        create: {
            method: 'PUT'
        }
    })
});
services.factory('visitorFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/ay881jsdL9r5/', {}, {
        init: {
            method: 'GET'
        },
        save_now: {
            method: 'PUT'
        }
    })
});
 
services.factory('spaceInfoFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/uA87IC3m8D1u/', {}, {
        query: {
            method: 'PUT'
        }
    })
});
services.factory('searchResultsFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/9MaG9c1WndY3a1/', {}, {
        query: {
            method: 'PUT'
        }
    })
});
services.factory('notifyFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/2GH01x96Q5uJ/', {}, {
        create: {
            method: 'PUT'
        }
    })
});
services.factory('clicksFactory', function ($resource) {
    return $resource('//www.optimalspaces.com/qrkjMmlVzwIl7/', {}, {
        create: {
            method: 'PUT'
        }
    })
});;'use strict';
angular.module('brian.directives', []).directive('focuson', [function () {
    return function focuson(scope, element, attr) {
        scope.$watch(attr.focuson, function (newVal) {
            if (newVal) {
                scope.$evalAsync(function() {
                    element[0].focus();
                });
            }
        });
    }
}]).directive('focusMe', function($timeout, $parse) {
  return {
    //scope: true,   // optionally create a child scope
    link: function(scope, element, attrs) {
      var model = $parse(attrs.focusMe);
      scope.$watch(model, function(value) {
        if(value === true) {
            $timeout(function() {
                //console.log(element);
              element[0].focus();
              element[0].autofocus = true;

            }, 100);
          }
      });
      // to address @blesh's comment, set attribute value to 'false'
      // on blur event:
      element.bind('blur', function() {

         scope.$apply(model.assign(scope, false));
      });
    }
  };
}).directive('ngDelay', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        scope: true,
        compile: function (element, attributes) {
            var expression = attributes['ngChange'];
            if (!expression)
                return;

            var ngModel = attributes['ngModel'];
            if (ngModel) attributes['ngModel'] = '$parent.' + ngModel;
            attributes['ngChange'] = '$$delay.execute()';

            return {
                post: function (scope, element, attributes) {
                    scope.$$delay = {
                        expression: expression,
                        delay: scope.$eval(attributes['ngDelay']),
                        execute: function () {
                            var state = scope.$$delay;
                            state.then = Date.now();
                            $timeout(function () {
                                if (Date.now() - state.then >= state.delay)
                                    scope.$parent.$eval(expression);
                            }, state.delay);
                        }
                    };
                }
            }
        }
    };
}]).directive('showMeButton', function ($window) {
    return {
      restrict: 'A',
      scope: {
          offset: "@",
          scrollClass: "@"
      },
      link: function(scope, element) {
          angular.element($window).bind("scroll", function() {
              if (this.pageYOffset >= parseInt(scope.offset)) {
                  element.addClass(scope.scrollClass);
              } else {
                element.removeClass(scope.scrollClass);
             }
          });
      }
    };
  }).directive('ddTextCollapse', ['$compile', function($compile) {

    return {
        restrict: 'A',
        scope: true,
        link: function(scope, element, attrs) {

            // start collapsed
            scope.collapsed = false;

            // create the function to toggle the collapse
            scope.toggle = function() {
                scope.collapsed = !scope.collapsed;
            };

            // wait for changes on the text
            attrs.$observe('ddTextCollapseText', function(text) {

                // get the length from the attributes
                var maxLength = scope.$eval(attrs.ddTextCollapseMaxLength);

                if (text.length > maxLength) {
                    // split the text in two parts, the first always showing
                    var firstPart = String(text).substring(0, maxLength);
                    var secondPart = String(text).substring(maxLength, text.length);

                    // create some new html elements to hold the separate info
                    var firstSpan = $compile('<span>' + firstPart + '</span>')(scope);
                    var secondSpan = $compile('<span ng-if="collapsed">' + secondPart + '</span>')(scope);
                    var moreIndicatorSpan = $compile('<span ng-if="!collapsed"></span>')(scope);
                    var lineBreak = $compile('<br ng-if="collapsed">')(scope);
                    var toggleButton = $compile('<span class="collapse-text-toggle" ng-click="toggle()" style="text-decoration: underline">{{collapsed ? "Read less" : "Read more"}}</span>')(scope);

                    // remove the current contents of the element
                    // and add the new ones we created
                    element.empty();
                    element.append(firstSpan);
                    element.append(secondSpan);
                    element.append(moreIndicatorSpan);
                    element.append(lineBreak);
                    element.append(toggleButton);
                }
                else {
                    element.empty();
                    element.append(text);
                }
            });
        }
    };
}]);